(function(){
const ASSETS=window.__HOOD_ASSETS__;
const HB_STAGE=`
<div class="stage">
<div class="veil" id="veil">Choose your vehicle to see the preview</div>
<div class="cap" id="cap" hidden>
</div>
</div>
`;
const HB_STEPS=`
<div class="hb-head">
<p class="hb-title">Build your hood decal</p>
<p class="hb-sub">Pick your hood, choose a design, and set your colours \u2014 the preview updates live.</p>
</div>
<div id="steps">
<section class="step" id="s1">
<h2>
<b>1</b> Choose your vehicle
    <button class="sum" type="button" id="s1sum" hidden>
<span id="s1txt">
</span>
<i>&#9662;</i>
</button>
</h2>
<div class="in" id="s1in">
<div class="grp">
<div class="lb">Year</div>
<select id="year">
</select>
</div>
<div class="grp" id="g-model" hidden>
<div class="lb">Model</div>
<select id="model">
</select>
</div>
<div class="grp" id="g-trim" hidden>
<div class="lb">Trim</div>
<select id="trim">
</select>
</div>
<div id="hoodwrap" hidden>
<div class="lb" style="margin-top:12px">Your hood</div>
<div id="hoodconfirm">
<p class="hint" style="margin-top:0">Based on your selection, this is your hood:</p>
<div class="lb" id="hoodguess">
</div>
<div class="row" style="margin-top:8px">
<button class="opt" type="button" id="hoodyes">Yes, that's my hood</button>
<button class="opt" type="button" id="hoodno">No \u2014 show other hoods</button>
</div>
</div>
<div id="hoodpick" hidden>
<div class="lb">Pick your hood shape</div>
<div class="hoodgrid" id="g-hood">
</div>
<p class="hint">Choose the shape that matches your vehicle, then confirm.</p>
<div class="row" style="margin-top:8px">
<button class="opt" type="button" id="hoodconfirm2">Confirm this hood</button>
</div>
</div>
<div id="hooddone" hidden>
<span class="pill" id="hoodlabel">
</span>
<button class="opt" type="button" id="hoodreset" style="margin-left:6px">Change</button>
</div>
</div>
<div id="vehcol" hidden>
<div class="lb" style="margin-top:14px">Your vehicle colour</div>
<div class="row" id="g-veh">
</div>
<p class="hint">Preview only \u2014 we do not colour match your paint.</p>
<button class="opt big" type="button" id="s1next" hidden style="margin-top:12px">Next step \u2014 choose your design</button>
</div>
</div>
</section>
<section class="step locked" id="s4">
<h2>
<b>2</b> Choose your decal design</h2>
<div class="in">
<div class="grp" id="modewrap">
<button class="opt big" type="button" data-k="mode" data-v="library">Ready Designs \u2014 Pick from CARCODE Designs Library <span class="from" id="from-lib">Starts from $100</span></button>
<button class="opt big" type="button" data-k="mode" data-v="custom">Build your own personalized design <span class="from" id="from-cus">Starts from $150</span></button>
</div>
<div class="grp" id="packwrap" hidden>
<div class="lb">What would you like?</div>
<div class="row" id="g-pack">
</div>
</div>
<div class="grp" id="g-lib" hidden>
<div class="lb">Hood decal design</div>
<p class="matchnote" id="sideoknote" hidden>With hood side decals, these are the hood designs made to go with them. For any other hood design, order the hood decal and the side decals separately.</p>
<div class="row" id="g-des">
</div>
<div class="setnote" id="setnote-h" hidden></div>
<div id="wrap-border2">
<div class="lb" style="margin-top:12px">Border</div>
<div class="row" id="g-border2">
</div>
</div>
</div>
<div class="grp" id="g-sidelib" hidden>
<div class="lb">Hood side decal design</div>
<p class="matchnote" id="matchnote" hidden><span class="match">\u2605 Matching set</span> These side decals were designed together with the hood decal you picked, for a complete look.</p>
<div class="row" id="g-side">
</div>
<div class="setnote" id="setnote-s" hidden></div>
</div>
<div class="grp" id="g-custom" hidden>
<div class="lb" style="font-size:14px">Hood decal \u2014 your artwork</div>
<div id="wrap-border">
<div class="lb">Outline border</div>
<div class="row" id="g-border">
</div>
</div>
<div class="lb" style="margin-top:12px">Upload your image or logo</div>
<input type="file" id="cfile" accept="image/*,.pdf,.ai,.eps,.svg">
<div id="imgctl" hidden>
<p class="dragnote">Drag your image on the preview to place it.</p>
<div class="lb" style="margin-top:8px">Image size <span class="num" id="isizen">100%</span>
</div>
<input type="range" id="isize" min="20" max="250" value="100" style="width:100%">
<div class="lb" style="margin-top:8px">Image rotation <span class="num" id="irotn">0\u00b0</span>
</div>
<input type="range" id="irot" min="-180" max="180" value="0" style="width:100%">
</div>
<p class="hint">Vector preferred (AI, EPS, SVG, PDF). High-resolution PNG or JPG also works.</p>
</div>
<div class="grp" id="g-scustom" hidden>
<div class="lb" style="font-size:14px" id="scus-title">Hood side decals \u2014 your artwork</div>
<p class="hint" id="scus-textonly" hidden>Personalized hood side decals are made with your own text: add it in step 4. It goes on both sides, mirrored.</p>
<div id="scus-upload">
<div class="lb" style="margin-top:8px">Upload your image or logo for the side decals</div>
<input type="file" id="sfile" accept="image/*,.pdf,.ai,.eps,.svg">
<p class="hint">It goes on both sides, mirrored.</p>
</div>
<div id="sictl" hidden>
<p class="dragnote">Drag it on either side panel; the other side follows, mirrored.</p>
<div class="lb" style="margin-top:8px">Image size <span class="num" id="sisizen">100%</span>
</div>
<input type="range" id="sisize" min="20" max="250" value="100" style="width:100%">
<div class="lb" style="margin-top:8px">Image rotation <span class="num" id="sirotn">0\u00b0</span>
</div>
<input type="range" id="sirot" min="-180" max="180" value="0" style="width:100%">
</div>
</div>
<div class="grp" id="g-cdesc" hidden>
<div class="promise">You will receive a full mockup designed for your approval
      before printing or production.</div>
<div class="lb" style="margin-top:12px">Describe what you want</div>
<textarea id="cdesc" rows="5" placeholder="Anything we should know that the options above don't cover. For example:&#10;- Match the style of the decals already on my truck (photo attached)&#10;- Keep my logo's original colours exactly as supplied&#10;- Give the artwork a worn, distressed finish&#10;- Mirror the logo so it reads correctly from the driver's seat&#10;- Use my brand font \u2014 file attached&#10;- Leave the area around the hood scoop uncovered">
</textarea>
</div>
</section>
<section class="step locked" id="s5">
<h2>
<b>3</b> Choose your decal colours</h2>
<div class="in">
<div class="grp" id="wrap-main">
<div class="lb" id="lb-main">Vinyl colour (main)</div>
<div class="row" id="g-main">
</div>
</div>
<div class="grp" id="wrap-acc">
<div class="lb"><span id="lb-acc">Graphics colour</span><span class="imgnote" id="accnote" hidden> \u2014 your uploaded artwork keeps its own colours in the preview; we apply this colour for you in the mockup.</span>
</div>
<div class="row" id="g-acc">
</div>
</div>
<div class="grp" id="wrap-acc2" hidden>
<div class="lb">2nd graphics colour</div>
<div class="row" id="g-acc2">
</div>
</div>
<div class="grp" id="wrap-bcol" hidden>
<div class="lb">Border colour</div>
<div class="row" id="g-bcol">
</div>
</div>
<div class="grp" id="wrap-scol" hidden>
<div class="lb">Hood side decals colour</div>
<div class="row" id="g-scol">
</div>
</div>
<p class="hint">Cut-out exposes your vehicle colour.</p>
</div>
</section>
<section class="step locked" id="s7">
<h2>
<b>4</b> Add your own text</h2>
<div class="in">
<div id="htextwrap">
<div class="lb" id="htextlb">Add text</div>
<div class="row" id="g-addtext">
</div>
<div class="grp" id="textblock" hidden>
<div class="lb">What would you like on the vinyl?</div>
<div class="row" id="g-txtsrc">
</div>
<div id="typewrap">
<div class="lb" style="margin-top:12px">Your text</div>
<input type="text" id="ctext" placeholder="e.g. 1941, your name, a slogan">
<p class="dragnote">Drag the text on the preview to place it anywhere on the vinyl.</p>
<div class="lb" style="margin-top:12px">Font</div>
<select id="cfont">
</select>
<input type="text" id="cfontother" placeholder="Font name, e.g. Bebas Neue, Anton, Oswald" hidden style="margin-top:6px">
<p class="hint" id="fonthint" hidden>Type any Google Font name and the preview updates. Other fonts are noted on your order.</p>
</div>
<div id="popwrap" hidden>
<div class="lb" style="margin-top:12px">Popular text for your Ford</div>
<div class="badgerow" id="g-badge">
</div>
<p class="dragnote">Drag it on the preview, and use its handles to turn or resize it.</p>
</div>
<div class="lb" style="margin-top:14px">Colour style</div>
<div class="row" id="g-txtduo">
</div>
<div id="tcolwrap">
<div class="lb" style="margin-top:10px">Fill colour</div>
<div class="row" id="g-tcol2">
</div>
<div id="toutwrap" hidden>
<div class="lb" style="margin-top:8px">Outline colour</div>
<div class="row" id="g-tout">
</div>
</div>
</div>
<div class="lb" style="margin-top:12px">Size <span class="num" id="csizen">100%</span>
</div>
<input type="range" id="csize" min="40" max="220" value="100" style="width:100%">
<div class="lb" style="margin-top:8px">Rotation <span class="num" id="crotn">0\u00b0</span>
</div>
<input type="range" id="crot" min="-180" max="180" value="0" style="width:100%">
</div>
</div>
<div id="stextwrap" hidden style="margin-top:16px">
<div class="lb">Text on the hood side decals</div>
<div class="row" id="g-saddtext">
</div>
<div class="grp" id="stextblock" hidden>
<div class="lb" style="margin-top:10px">Your text</div>
<input type="text" id="stext" placeholder="e.g. F-150, your name, a slogan">
<p class="hint">It appears on both side decals, mirrored.</p>
<p class="dragnote">Drag the text on either side panel; the other side follows.</p>
<div class="lb" style="margin-top:12px">Font</div>
<select id="sfont">
</select>
<input type="text" id="sfontother" placeholder="Font name, e.g. Bebas Neue, Anton, Oswald" hidden style="margin-top:6px">
<p class="hint" id="sfonthint" hidden>Type any Google Font name and the preview updates. Other fonts are noted on your order.</p>
<div class="lb" style="margin-top:14px">Colour style</div>
<div class="row" id="g-sduo">
</div>
<div class="lb" style="margin-top:10px">Fill colour</div>
<div class="row" id="g-stcol">
</div>
<div id="stoutwrap" hidden>
<div class="lb" style="margin-top:8px">Outline colour</div>
<div class="row" id="g-stout">
</div>
</div>
<div class="lb" style="margin-top:12px">Size <span class="num" id="ssizen">100%</span>
</div>
<input type="range" id="ssize" min="40" max="220" value="100" style="width:100%">
<div class="lb" style="margin-top:8px">Rotation <span class="num" id="srotn">0\u00b0</span>
</div>
<input type="range" id="srot" min="-180" max="180" value="0" style="width:100%">
</div>
</div>
</section>
<div class="tot">
<div class="amt" id="price">$99.00</div>
<code id="spec">Complete the steps above.</code>
</div>
`;
(function place(){
  const root=document.getElementById('hood-builder-root');
  root.className='hood-builder';
  root.innerHTML='<div class="hb-grid"><div class="hb-col-preview">'+HB_STAGE+'</div>'+
                 '<div class="hb-col-steps">'+HB_STEPS+'</div></div>';
  function widen(){
    try{
      // hide a media column that has no photos
      document.querySelectorAll('[class*="media"]').forEach(el=>{
        if(el===root||el.contains(root)) return;
        const cls=el.className||'';
        if(typeof cls==='string' && /media-(wrapper|list|gallery)|product__media/.test(cls)
           && !el.querySelector('img,video,model-viewer,iframe')) el.style.display='none';
      });
      // walk up from the builder and let every wrapper span the full row
      let el=root, guard=0;
      while(el && el!==document.body && guard++<12){
        const cs=getComputedStyle(el);
        el.style.setProperty('max-width','100%','important');
        el.style.setProperty('width','100%','important');
        el.style.setProperty('flex','1 1 100%','important');
        el.style.setProperty('grid-column','1 / -1','important');
        if(cs.display==='grid'||cs.display==='flex'){
          el.style.setProperty('grid-template-columns','1fr','important');
        }
        if(/page-width|shopify-section/.test(el.className||'')) break;
        el=el.parentElement;
      }
    }catch(e){}
  }
  widen(); setTimeout(widen,300); window.addEventListener('load',widen);
})();

const D={
 /* Fitment from Ford_F-150__Bronco_Trim_Reference_Guide.pdf */
 "fit": {
  "models": {"f150":{"label":"F-150"}, "lightning":{"label":"F-150 Lightning"},
             "f150raptor":{"label":"F-150 Raptor"}, "bronco":{"label":"Bronco"},
             "broncoraptor":{"label":"Bronco Raptor"}},
  "years": {
   "2015":["f150"],"2016":["f150"],"2017":["f150"],"2018":["f150"],"2019":["f150"],"2020":["f150"],
   "2021":["f150","f150raptor","bronco"],
   "2022":["f150","lightning","f150raptor","bronco","broncoraptor"],
   "2023":["f150","lightning","f150raptor","bronco","broncoraptor"],
   "2024":["f150","lightning","f150raptor","bronco","broncoraptor"],
   "2025":["f150","lightning","f150raptor","bronco","broncoraptor"],
   "2026":["f150","lightning","f150raptor","bronco","broncoraptor"]},
  "trims": {
   "f150": [
    {"id":"xl_13","label":"XL","r":[[2015,2020]],"hood":"std13","note":"13th gen"},
    {"id":"xlt_13","label":"XLT","r":[[2015,2020]],"hood":"std13","note":"13th gen"},
    {"id":"lariat_13","label":"Lariat","r":[[2015,2020]],"hood":"std13","note":"13th gen"},
    {"id":"kingranch_13","label":"King Ranch","r":[[2015,2020]],"hood":"std13","note":"13th gen"},
    {"id":"platinum_13","label":"Platinum","r":[[2015,2020]],"hood":"std13","note":"13th gen"},
    {"id":"limited_13","label":"Limited","r":[[2015,2020]],"hood":"std13","note":"13th gen"},
    {"id":"police_13","label":"Police Responder / SSV","r":[[2015,2020]],"hood":"std13","note":"13th gen"},
    {"id":"xl_14","label":"XL","r":[[2021,2026]],"hood":"std14","note":"14th gen"},
    {"id":"xlt_14","label":"XLT","r":[[2021,2026]],"hood":"std14","note":"14th gen"},
    {"id":"lariat_14","label":"Lariat","r":[[2021,2026]],"hood":"std14","note":"14th gen"},
    {"id":"kingranch_14","label":"King Ranch","r":[[2021,2023]],"hood":"std14","note":"14th gen pre-facelift"},
    {"id":"platinum_14","label":"Platinum","r":[[2021,2023]],"hood":"std14","note":"14th gen pre-facelift"},
    {"id":"limited_14","label":"Limited","r":[[2021,2023]],"hood":"std14","note":"14th gen pre-facelift"},
    {"id":"stx_14","label":"STX","r":[[2024,2026]],"hood":"std14","note":"14th gen facelift"},
    {"id":"platinumplus_14","label":"Platinum Plus","r":[[2024,2026]],"hood":"std14","note":"14th gen facelift"}
   ],
   "lightning": [
    {"id":"pro","label":"Pro","r":[[2022,2026]],"hood":"lightning","note":""},
    {"id":"xlt","label":"XLT","r":[[2022,2026]],"hood":"lightning","note":""},
    {"id":"lariat","label":"Lariat","r":[[2022,2026]],"hood":"lightning","note":""},
    {"id":"platinum","label":"Platinum","r":[[2022,2026]],"hood":"lightning","note":""},
    {"id":"flash","label":"Flash","r":[[2022,2026]],"hood":"lightning","note":""}
   ],
   "f150raptor": [
    {"id":"raptor","label":"Raptor","r":[[2021,2026]],"hood":"raptor","note":"SuperCrew only"}
   ],
   "bronco": [
    {"id":"base","label":"Base","r":[[2021,2026]],"hood":"bronco","note":""},
    {"id":"bigbend","label":"Big Bend","r":[[2021,2026]],"hood":"bronco","note":""},
    {"id":"blackdiamond","label":"Black Diamond","r":[[2021,2026]],"hood":"bronco","note":""},
    {"id":"outerbanks","label":"Outer Banks","r":[[2021,2026]],"hood":"bronco","note":""},
    {"id":"badlands","label":"Badlands","r":[[2021,2026]],"hood":"bronco","note":""},
    {"id":"wildtrak","label":"Wildtrak","r":[[2021,2026]],"hood":"bronco","note":""},
    {"id":"everglades","label":"Everglades","r":[[2021,2026]],"hood":"bronco","note":""},
    {"id":"heritage","label":"Heritage","r":[[2021,2026]],"hood":"bronco","note":""},
    {"id":"firstedition","label":"First Edition","r":[[2021,2026]],"hood":"bronco","note":""},
    {"id":"stroppe","label":"Stroppe Edition","r":[[2021,2026]],"hood":"bronco","note":""}
   ],
   "broncoraptor": [
    {"id":"broncoraptor","label":"Raptor","r":[[2022,2026]],"hood":"broncoR","note":"4-Door only"}
   ]
  }
 },
 "hoods": {
  "f150": [["std13","F-150 Hood (2015-2020)"],["std14","F-150 Hood (2021-2026)"]],
  "lightning": [["lightning","Lightning Hood (Power Frunk)"]],
  "f150raptor": [["raptor","Raptor Vented Hood"]],
  "bronco": [["bronco","Bronco Hood"]],
  "broncoraptor": [["broncoR","Bronco Raptor Vented Hood"]]
 },
 "thumbs": {}
};
const FAM={};
const LOADED={};
async function loadFam(f){
  if(LOADED[f]) return LOADED[f];
  LOADED[f]=(async()=>{
    let j;
    try{
      // the library can be handed over directly (no fetch - some sandboxes block data: URLs)
      // a hood with its own fitted library uses it; the rest share the plain one
      if(window.__HOOD_LIBS__ && window.__HOOD_LIBS__[f]) j=window.__HOOD_LIBS__[f];
      // a big fitted library can live in its own file next to the page, loaded when that hood is picked
      else if(ASSETS[f] && ASSETS[f].lib){ const r=await fetch(ASSETS[f].lib,{cache:"force-cache"}); if(!r.ok) throw new Error("library "+r.status); j=await r.json(); }
      else if(window.__HOOD_LIB__) j=window.__HOOD_LIB__;
      else { const r=await fetch(ASSETS[f].json,{cache:"force-cache"}); j=await r.json(); }
    }
    catch(e){
      console.error("hood assets failed for "+f,e);
      const v=$("veil"); if(v){ v.hidden=false; v.textContent="Could not load the design library."; }
      LOADED[f]=null; throw e;
    }
    FAM[f]=j.meta;
    const div=document.createElement("div"); div.className="veh"; div.dataset.fam=f; div.hidden=true;
    const A=ASSETS[f]||{};
    // one shared design library serves every hood: re-prefix its ids for this family,
    // and apply this hood's own placement rectangle
    let layers=String(j.layers).split("_f150_").join("_"+f+"_")
                               .split('data-fam="f150"').join('data-fam="'+f+'"');
    // the hood decals and the hood-side decals land on different parts of the hood, so
    // each group has its own rectangle. A hood without its own side numbers reuses the
    // hood one rather than rendering nothing.
    if(A.place)     layers=layers.split("__PL_HOOD__").join(A.place);
    if(A.placeSide||A.place) layers=layers.split("__PL_SIDE__").join(A.placeSide||A.place);
    j=Object.assign({}, j, {layers:layers});
    div.innerHTML = (A.base
      ? `<img src="${A.base}" alt="Ford hood"><div class="paint" style="-webkit-mask-image:url(${A.mask});mask-image:url(${A.mask})"><img class="sh" src="${A.shade}" alt=""><img class="sp" src="${A.spec}" alt=""></div>`
      : `<div class="paint nophoto"></div>`) +
      // decals sit under the cowl, wipers and windshield: only the painted body shows them
      (A.base ? `<div class="decals" style="-webkit-mask-image:url(${A.mask});mask-image:url(${A.mask})">${layers}</div>` : layers);
    const st=document.querySelector(".stage"); st.insertBefore(div,$("veil"));
    // light the vinyl with the hood's own light and shadow, so it reads as a decal on
    // the paint rather than a flat cut-out on top. The light is clipped to the pixels the
    // vinyl actually covers, so cut-outs and bare paint are untouched.
    if(A.light){
      const sv=div.querySelector("svg.decal");
      const vb=String(sv&&sv.getAttribute("viewBox")||"").split(/[\s,]+/).map(Number);
      const pl={}; String(A.place||"").replace(/(left|top|width|height):\s*(-?[\d.]+)%/g,(m,k,v)=>{pl[k]=+v/100;});
      if(vb.length===4 && pl.width && pl.height){
        const ix=vb[0]-pl.left/pl.width*vb[2], iw=vb[2]/pl.width;
        const iy=vb[1]-pl.top/pl.height*vb[3], ih=vb[3]/pl.height;
        const fs=document.createElementNS("http://www.w3.org/2000/svg","svg");
        fs.setAttribute("width","0"); fs.setAttribute("height","0"); fs.setAttribute("aria-hidden","true");
        fs.style.position="absolute";
        fs.innerHTML=`<filter id="lt_${f}" filterUnits="userSpaceOnUse" primitiveUnits="userSpaceOnUse" `+
          `x="${ix}" y="${iy}" width="${iw}" height="${ih}" color-interpolation-filters="sRGB">`+
          `<feImage href="${A.light}" xlink:href="${A.light}" x="${ix}" y="${iy}" width="${iw}" height="${ih}" preserveAspectRatio="none" result="L"/>`+
          `<feComposite in="L" in2="SourceAlpha" operator="in" result="Lm"/>`+
          `<feBlend in="SourceGraphic" in2="Lm" mode="screen"/></filter>`;
        div.appendChild(fs);
        div.querySelectorAll("svg.decal .solid").forEach(g=>g.setAttribute("filter","url(#lt_"+f+")"));
      }
    }
    return j;
  })();
  return LOADED[f];
}
let fam="f13";
const COL0=[{id:"black",label:"Black",hex:"#1C1C1C"},{id:"beige",label:"Beige",hex:"#EAE0C8"},{id:"blue",label:"Blue",hex:"#1C659D"},{id:"bronze",label:"Bronze",hex:"#825A3F"},{id:"brown",label:"Brown",hex:"#5E3A21"},{id:"dark_green",label:"Dark Green",hex:"#004726"},{id:"dark_grey",label:"Dark Grey",hex:"#555555"},{id:"dark_orange",label:"Dark Orange",hex:"#F26522"},{id:"dark_red",label:"Dark Red",hex:"#B21F29"},{id:"gold",label:"Gold",hex:"#9D814B"},{id:"green",label:"Green",hex:"#00945E"},{id:"grey",label:"Grey",hex:"#808080"},{id:"hot_pink",label:"Hot Pink",hex:"#EC008C"},{id:"intense_blue",label:"Intense Blue",hex:"#21409A"},{id:"light_blue",label:"Light Blue",hex:"#00AEEF"},{id:"light_grey",label:"Light Grey",hex:"#D3D3D3"},{id:"olive",label:"Olive",hex:"#999B50"},{id:"orange",label:"Orange",hex:"#F7941D"},{id:"pink",label:"Pink",hex:"#F49AC1"},{id:"red",label:"Red",hex:"#ED1C24"},{id:"teal",label:"Teal",hex:"#1A8CA1"},{id:"violet",label:"Violet",hex:"#4B3C76"},{id:"white",label:"White",hex:"#FFFFFF"},{id:"yellow",label:"Yellow",hex:"#FFDE00"}];
const PAINT={
 oxford_white:["Oxford White","#F2F3F2"], agate_black:["Agate Black","#131313"],
 iconic_silver:["Iconic Silver","#9DA1A4"], carbonized_gray:["Carbonized Gray","#5A5D61"],
 stone_gray:["Stone Gray","#6E6A63"], rapid_red:["Rapid Red","#8E2420"],
 race_red:["Race Red","#C8102E"], velocity_blue:["Velocity Blue","#2E5FA3"],
 atlas_blue:["Atlas Blue","#1D3A63"], antimatter_blue:["Antimatter Blue","#33475B"],
 lead_foot:["Lead Foot Gray","#6B6E70"], magnetic:["Magnetic","#6D7073"],
 blue_jeans:["Blue Jeans","#3F6FA8"], star_white:["Star White","#EDEDE8"],
 area_51:["Area 51","#7E8F93"]};
const FORD_PAINT=["oxford_white","agate_black","iconic_silver","carbonized_gray","stone_gray","rapid_red","race_red","velocity_blue","atlas_blue","antimatter_blue","lead_foot","magnetic","blue_jeans","star_white","area_51"];
const VEHSETS={f13:FORD_PAINT,f14:FORD_PAINT,light:FORD_PAINT,raptor:FORD_PAINT,bronco:FORD_PAINT,broncoR:FORD_PAINT};
const OTHER={id:"other",label:"Other \u2014 type a colour",other:true,hex:"#888888"};
function vehList(){return (VEHSETS[fam]||FORD_PAINT).map(id=>({id,label:PAINT[id][0],hex:PAINT[id][1]})).concat([OTHER]);}
function cssColour(s){ if(!s) return null; let v=String(s).trim(); if(!v) return null;
  let h=v.replace(/^#/,""); if(/^[0-9a-f]{3}$/i.test(h)) h=h.split("").map(c=>c+c).join("");
  if(/^[0-9a-f]{6}$/i.test(h)) return "#"+h.toLowerCase();
  const t=document.createElement("span"); t.style.color=""; t.style.color=v;
  if(!t.style.color) return null;
  document.body.appendChild(t); const c=getComputedStyle(t).color||t.style.color; t.remove();
  const m=c&&c.match(/rgba?\((\d+)[,\s]+(\d+)[,\s]+(\d+)/);
  if(m) return "#"+[1,2,3].map(i=>(+m[i]).toString(16).padStart(2,"0")).join("");
  const hm=c&&c.match(/^#([0-9a-f]{3,6})$/i); if(hm) return c.toLowerCase();
  return null; }
function pick(list,key){ const o=list.find(c=>c.id===S[key]); if(!o) return null;
  if(o.other){ const hx=cssColour(S[key+"_txt"]); return {id:"other",label:(S[key+"_txt"]||"custom"),hex:hx||"#888888",unknown:!hx}; }
  return o; }
let VEH=vehList();
const COL=COL0.concat([OTHER]);
const SRCSEL=[{id:"type",label:"Type my own text"},{id:"popular",label:"Popular Ford text"}];
const DUO=[{id:"one",label:"Single colour"},{id:"two",label:"Two colours (outline + fill)"}];
const CUT={id:"cutout",label:"Cut-out \u2014 no vinyl here, your paint shows through. Cut for you, ready to install.",cut:true};
const FONTS=[["Impact, sans-serif","Impact \u2014 bold condensed"],
 ["'Arial Black', Arial, sans-serif","Arial Black \u2014 heavy"],
 ["'Franklin Gothic Medium','Arial Narrow',sans-serif","Franklin Gothic"],
 ["'Arial Narrow', Arial, sans-serif","Arial Narrow"],
 ["Arial, Helvetica, sans-serif","Arial"],
 ["'Helvetica Neue', Helvetica, sans-serif","Helvetica"],
 ["Verdana, sans-serif","Verdana"],
 ["Tahoma, sans-serif","Tahoma"],
 ["'Trebuchet MS', sans-serif","Trebuchet"],
 ["'Century Gothic','Questrial',sans-serif","Century Gothic"],
 ["Georgia, serif","Georgia \u2014 serif"],
 ["'Times New Roman', Times, serif","Times New Roman"],
 ["Garamond, serif","Garamond"],
 ["'Palatino Linotype', Palatino, serif","Palatino"],
 ["'Courier New', monospace","Courier \u2014 stencil feel"],
 ["'Lucida Console', monospace","Lucida Console"],
 ["'Copperplate','Copperplate Gothic Light',serif","Copperplate"],
 ["'Brush Script MT', cursive","Brush Script"],
 ["'Segoe Script','Bradley Hand',cursive","Segoe Script"]];
const VIN=[CUT].concat(COL);
// outline colours: the paint colours plus cut-out (an outline of bare paint around coloured letters)
const TOUT=[CUT].concat(COL0);
const BORDER=[{id:"no",label:"No border"},{id:"yes",label:"Add border"}];
const ADDT=[{id:"no",label:"No text"},{id:"yes",label:"Add text  +$20"}];
const ADDT_FREE=[{id:"no",label:"No text"},{id:"yes",label:"Add text (included)"}];
let ORDERK=[];
let UIMG=null, UIW=0, UIH=0;
let SIMG=null, SIW=0, SIH=0;     // the side-decal artwork (personalised side decals)
const sideImgOK=()=>!(FAM[fam]&&FAM[fam].sideNoImage);   // 2021+ side decals: text only
const BADGES={"f150":{"label":"F-150","vb":"-11.246 -11.450 2022.522 349.902","outer":["M7.5 305.8C11.5 294.1 18.0 275.5 21.8 264.5C25.7 253.5 32.7 233.2 37.5 219.5C42.3 205.8 50.8 181.2 56.5 165.0C62.1 148.8 74.1 114.4 83.0 88.7C93.3 59.2 100.7 39.7 102.9 35.9C110.2 23.4 122.6 12.3 136.1 6.1C150.1 -0.4 132.7 0.0 372.2 0.0C492.0 0.0 590.0 0.3 590.0 0.8C590.0 1.2 584.7 16.6 578.2 35.0L566.3 68.5L406.4 69.0C256.1 69.5 246.2 69.6 242.0 71.3C232.3 75.2 221.5 84.3 217.4 92.1C216.0 94.9 200.0 139.4 200.0 140.6C200.0 140.8 252.8 141.1 317.4 141.2L434.8 141.5L427.9 161.0C424.1 171.7 419.6 184.4 417.9 189.2L414.8 198.0L297.3 198.2L179.7 198.5L166.5 237.0C159.2 258.2 149.2 287.0 144.3 301.0L135.5 326.5L67.8 326.8L0.2 327.0L7.5 305.8ZM663.0 326.6C663.0 326.4 683.1 269.4 707.6 199.9C732.2 130.4 752.5 72.5 752.8 71.2L753.2 69.0L737.1 69.0C728.3 69.0 721.0 68.9 721.0 68.7C721.0 68.6 726.4 53.2 733.0 34.6C739.6 16.0 745.0 0.6 745.0 0.4C745.0 0.2 783.3 0.0 830.1 0.0C910.8 0.0 915.2 0.1 914.5 1.8C914.2 2.7 909.4 16.1 904.0 31.5C898.6 46.9 873.6 117.8 848.5 189.0C823.3 260.2 802.1 320.4 801.3 322.8L799.8 327.0L731.4 327.0C693.8 327.0 663.0 326.8 663.0 326.6ZM858.0 326.2C858.0 325.8 862.3 313.3 867.5 298.6C872.7 283.8 877.0 271.6 877.0 271.4C877.0 271.2 953.0 271.0 1046.0 271.0C1167.1 271.0 1216.4 270.7 1220.2 269.9C1231.7 267.4 1238.1 261.6 1242.8 249.1C1246.5 239.5 1250.0 225.7 1250.0 221.0C1250.0 215.3 1247.3 207.7 1244.3 204.8C1237.8 198.6 1250.1 199.0 1066.5 199.0C924.7 199.0 899.0 198.8 899.0 197.6C899.0 196.9 912.8 158.3 929.6 111.9C946.4 65.5 962.2 21.9 964.6 15.0C967.1 8.1 969.4 1.9 969.8 1.2C970.5 0.2 1018.7 0.0 1207.7 0.2L1444.8 0.5L1432.8 34.7L1420.7 69.0L1251.7 69.2L1082.6 69.5L1070.8 103.0C1064.3 121.4 1058.7 137.5 1058.4 138.8L1057.8 141.0L1209.6 141.0C1375.3 140.9 1372.4 140.8 1384.6 146.6C1399.4 153.6 1407.5 171.7 1403.7 189.5C1401.9 198.0 1377.6 267.7 1372.4 279.2C1359.4 308.2 1340.9 322.6 1312.0 326.0C1301.8 327.2 858.0 327.4 858.0 326.2ZM1434.7 325.9C1429.5 324.7 1425.6 322.5 1420.9 318.3C1416.0 313.9 1413.6 309.4 1412.0 301.7C1410.0 291.8 1410.5 290.0 1434.0 222.5C1436.1 216.4 1441.3 201.6 1445.5 189.5C1454.2 164.4 1459.3 149.9 1465.5 132.0C1469.6 120.1 1481.9 84.7 1491.7 56.5C1494.2 49.3 1497.7 40.8 1499.5 37.5C1508.3 21.8 1522.9 9.5 1540.2 3.2L1547.5 0.5L1760.0 0.2C1993.3 -0.0 1977.5 -0.4 1987.1 6.0C1995.9 11.7 2000.7 23.0 1999.7 34.9C1999.2 41.1 1991.9 63.0 1962.0 148.5C1954.9 168.7 1940.2 211.2 1929.0 243.5C1922.9 261.1 1916.8 278.4 1915.4 281.9C1907.4 302.4 1888.7 318.9 1866.8 325.0C1859.6 327.0 1857.5 327.0 1649.0 326.9C1529.8 326.8 1436.9 326.4 1434.7 325.9ZM1760.4 269.5C1770.6 266.8 1781.1 259.2 1786.8 250.3C1788.7 247.3 1799.6 217.3 1816.1 170.0C1839.7 102.1 1842.4 93.9 1842.4 88.2C1842.4 82.9 1841.9 81.3 1839.4 77.8C1837.8 75.5 1834.7 72.7 1832.5 71.6C1828.5 69.5 1827.9 69.5 1735.9 69.5L1643.4 69.5L1635.7 73.3C1627.2 77.5 1619.8 84.1 1615.7 91.1C1614.2 93.6 1601.3 129.4 1586.9 170.6C1558.4 252.5 1558.5 252.2 1562.9 260.8C1564.1 263.1 1566.1 265.7 1567.5 266.6C1574.2 271.0 1573.2 270.9 1666.0 271.0C1741.9 271.0 1755.4 270.8 1760.4 269.5ZM482.6 195.8C482.9 194.5 487.4 181.8 492.4 167.5L501.5 141.5L579.2 141.2C622.0 141.1 657.0 141.1 657.0 141.3C657.0 141.5 652.5 154.2 647.1 169.5L637.2 197.5L559.5 197.8L481.9 198.0L482.6 195.8Z"],"inner":["M7.5 305.8C11.5 294.1 18.0 275.5 21.8 264.5C25.7 253.5 32.7 233.2 37.5 219.5C42.3 205.8 50.8 181.2 56.5 165.0C62.1 148.8 74.1 114.4 83.0 88.7C93.3 59.2 100.7 39.7 102.9 35.9C110.2 23.4 122.6 12.3 136.1 6.1C150.1 -0.4 132.7 0.0 372.2 0.0C492.0 0.0 590.0 0.3 590.0 0.8C590.0 1.2 584.7 16.6 578.2 35.0L566.3 68.5L406.4 69.0C256.1 69.5 246.2 69.6 242.0 71.3C232.3 75.2 221.5 84.3 217.4 92.1C216.0 94.9 200.0 139.4 200.0 140.6C200.0 140.8 252.8 141.1 317.4 141.2L434.8 141.5L427.9 161.0C424.1 171.7 419.6 184.4 417.9 189.2L414.8 198.0L297.3 198.2L179.7 198.5L166.5 237.0C159.2 258.2 149.2 287.0 144.3 301.0L135.5 326.5L67.8 326.8L0.2 327.0L7.5 305.8ZM663.0 326.6C663.0 326.4 683.1 269.4 707.6 199.9C732.2 130.4 752.5 72.5 752.8 71.2L753.2 69.0L737.1 69.0C728.3 69.0 721.0 68.9 721.0 68.7C721.0 68.6 726.4 53.2 733.0 34.6C739.6 16.0 745.0 0.6 745.0 0.4C745.0 0.2 783.3 0.0 830.1 0.0C910.8 0.0 915.2 0.1 914.5 1.8C914.2 2.7 909.4 16.1 904.0 31.5C898.6 46.9 873.6 117.8 848.5 189.0C823.3 260.2 802.1 320.4 801.3 322.8L799.8 327.0L731.4 327.0C693.8 327.0 663.0 326.8 663.0 326.6ZM858.0 326.2C858.0 325.8 862.3 313.3 867.5 298.6C872.7 283.8 877.0 271.6 877.0 271.4C877.0 271.2 953.0 271.0 1046.0 271.0C1167.1 271.0 1216.4 270.7 1220.2 269.9C1231.7 267.4 1238.1 261.6 1242.8 249.1C1246.5 239.5 1250.0 225.7 1250.0 221.0C1250.0 215.3 1247.3 207.7 1244.3 204.8C1237.8 198.6 1250.1 199.0 1066.5 199.0C924.7 199.0 899.0 198.8 899.0 197.6C899.0 196.9 912.8 158.3 929.6 111.9C946.4 65.5 962.2 21.9 964.6 15.0C967.1 8.1 969.4 1.9 969.8 1.2C970.5 0.2 1018.7 0.0 1207.7 0.2L1444.8 0.5L1432.8 34.7L1420.7 69.0L1251.7 69.2L1082.6 69.5L1070.8 103.0C1064.3 121.4 1058.7 137.5 1058.4 138.8L1057.8 141.0L1209.6 141.0C1375.3 140.9 1372.4 140.8 1384.6 146.6C1399.4 153.6 1407.5 171.7 1403.7 189.5C1401.9 198.0 1377.6 267.7 1372.4 279.2C1359.4 308.2 1340.9 322.6 1312.0 326.0C1301.8 327.2 858.0 327.4 858.0 326.2ZM1434.7 325.9C1429.5 324.7 1425.6 322.5 1420.9 318.3C1416.0 313.9 1413.6 309.4 1412.0 301.7C1410.0 291.8 1410.5 290.0 1434.0 222.5C1436.1 216.4 1441.3 201.6 1445.5 189.5C1454.2 164.4 1459.3 149.9 1465.5 132.0C1469.6 120.1 1481.9 84.7 1491.7 56.5C1494.2 49.3 1497.7 40.8 1499.5 37.5C1508.3 21.8 1522.9 9.5 1540.2 3.2L1547.5 0.5L1760.0 0.2C1993.3 -0.0 1977.5 -0.4 1987.1 6.0C1995.9 11.7 2000.7 23.0 1999.7 34.9C1999.2 41.1 1991.9 63.0 1962.0 148.5C1954.9 168.7 1940.2 211.2 1929.0 243.5C1922.9 261.1 1916.8 278.4 1915.4 281.9C1907.4 302.4 1888.7 318.9 1866.8 325.0C1859.6 327.0 1857.5 327.0 1649.0 326.9C1529.8 326.8 1436.9 326.4 1434.7 325.9ZM1760.4 269.5C1770.6 266.8 1781.1 259.2 1786.8 250.3C1788.7 247.3 1799.6 217.3 1816.1 170.0C1839.7 102.1 1842.4 93.9 1842.4 88.2C1842.4 82.9 1841.9 81.3 1839.4 77.8C1837.8 75.5 1834.7 72.7 1832.5 71.6C1828.5 69.5 1827.9 69.5 1735.9 69.5L1643.4 69.5L1635.7 73.3C1627.2 77.5 1619.8 84.1 1615.7 91.1C1614.2 93.6 1601.3 129.4 1586.9 170.6C1558.4 252.5 1558.5 252.2 1562.9 260.8C1564.1 263.1 1566.1 265.7 1567.5 266.6C1574.2 271.0 1573.2 270.9 1666.0 271.0C1741.9 271.0 1755.4 270.8 1760.4 269.5ZM482.6 195.8C482.9 194.5 487.4 181.8 492.4 167.5L501.5 141.5L579.2 141.2C622.0 141.1 657.0 141.1 657.0 141.3C657.0 141.5 652.5 154.2 647.1 169.5L637.2 197.5L559.5 197.8L481.9 198.0L482.6 195.8Z"],"stroke":16.351,"ratio":0.17300296180706584},"bronco":{"label":"Bronco","vb":"94.177 55.187 256.505 17.985","outer":["M169.58,63.34c.94-.28,1.63-1.15,1.63-2.18v-2.94c0-1.26-1.02-2.28-2.28-2.28h-29.32v16.49h10.47v-5.95c0-.36.29-.64.64-.64h9.37c.36,0,.64.29.64.64v5.95h10.47v-5.22c0-1.03-.69-1.9-1.63-2.18-.36-.11-.63-.44-.63-.84s.26-.73.63-.84M160.73,61.89c0,.36-.29.64-.64.64h-10.01v-3.3h10.01c.36,0,.64.29.64.64v2.01Z","M347.66,55.94h-27.04c-1.26,0-2.28,1.02-2.28,2.28v11.93c0,1.26,1.02,2.28,2.28,2.28h27.04c1.26,0,2.28-1.02,2.28-2.28v-11.93c0-1.26-1.02-2.28-2.28-2.28M339.47,59.88v8.61c0,.36-.29.64-.64.64h-9.37c-.35,0-.64-.29-.64-.64v-8.61c0-.36.29-.64.64-.64h9.37c.36,0,.64.29.64.64","M294.78,66.22v2.27c0,.35-.29.64-.64.64h-9.37c-.35,0-.64-.29-.64-.64v-8.61c0-.36.29-.64.64-.64h9.37c.35,0,.64.29.64.64v2.26h10.47v-3.93c0-1.26-1.02-2.28-2.28-2.28h-27.04c-1.26,0-2.28,1.02-2.28,2.28v11.93c0,1.26,1.02,2.28,2.28,2.28h27.04c1.26,0,2.28-1.02,2.28-2.28v-3.93h-10.47Z","M228.96,72.42v-16.49h10.84l9.48,9.71c.29.3.8.09.8-.33v-9.38h10.47v16.49h-10.84l-9.48-9.71c-.29-.3-.8-.09-.8.33v9.38h-10.47Z","M124.89,63.34c.94-.28,1.63-1.15,1.63-2.18v-2.94c0-1.26-1.02-2.28-2.28-2.28h-29.32v16.49h29.32c1.26,0,2.28-1.02,2.28-2.28v-2.95c0-1.03-.69-1.9-1.63-2.18-.36-.11-.63-.44-.63-.84s.27-.73.63-.84M116.04,68.48c0,.36-.29.64-.64.64h-10.01v-3.3h10.01c.36,0,.64.29.64.64v2.01ZM116.04,61.89c0,.36-.29.64-.64.64h-10.01v-3.3h10.01c.36,0,.64.29.64.64v2.01Z","M213.59,55.94h-27.04c-1.26,0-2.28,1.02-2.28,2.28v11.93c0,1.26,1.02,2.28,2.28,2.28h27.04c1.26,0,2.28-1.02,2.28-2.28v-11.93c0-1.26-1.02-2.28-2.28-2.28M205.4,59.88v8.61c0,.36-.29.64-.64.64h-9.37c-.36,0-.64-.29-.64-.64v-8.61c0-.36.29-.64.64-.64h9.37c.36,0,.64.29.64.64"],"inner":["M169.58,63.34c.94-.28,1.63-1.15,1.63-2.18v-2.94c0-1.26-1.02-2.28-2.28-2.28h-29.32v16.49h10.47v-5.95c0-.36.29-.64.64-.64h9.37c.36,0,.64.29.64.64v5.95h10.47v-5.22c0-1.03-.69-1.9-1.63-2.18-.36-.11-.63-.44-.63-.84s.26-.73.63-.84M160.73,61.89c0,.36-.29.64-.64.64h-10.01v-3.3h10.01c.36,0,.64.29.64.64v2.01Z","M347.66,55.94h-27.04c-1.26,0-2.28,1.02-2.28,2.28v11.93c0,1.26,1.02,2.28,2.28,2.28h27.04c1.26,0,2.28-1.02,2.28-2.28v-11.93c0-1.26-1.02-2.28-2.28-2.28M339.47,59.88v8.61c0,.36-.29.64-.64.64h-9.37c-.35,0-.64-.29-.64-.64v-8.61c0-.36.29-.64.64-.64h9.37c.36,0,.64.29.64.64","M294.78,66.22v2.27c0,.35-.29.64-.64.64h-9.37c-.35,0-.64-.29-.64-.64v-8.61c0-.36.29-.64.64-.64h9.37c.35,0,.64.29.64.64v2.26h10.47v-3.93c0-1.26-1.02-2.28-2.28-2.28h-27.04c-1.26,0-2.28,1.02-2.28,2.28v11.93c0,1.26,1.02,2.28,2.28,2.28h27.04c1.26,0,2.28-1.02,2.28-2.28v-3.93h-10.47Z","M228.96,72.42v-16.49h10.84l9.48,9.71c.29.3.8.09.8-.33v-9.38h10.47v16.49h-10.84l-9.48-9.71c-.29-.3-.8-.09-.8.33v9.38h-10.47Z","M124.89,63.34c.94-.28,1.63-1.15,1.63-2.18v-2.94c0-1.26-1.02-2.28-2.28-2.28h-29.32v16.49h29.32c1.26,0,2.28-1.02,2.28-2.28v-2.95c0-1.03-.69-1.9-1.63-2.18-.36-.11-.63-.44-.63-.84s.27-.73.63-.84M116.04,68.48c0,.36-.29.64-.64.64h-10.01v-3.3h10.01c.36,0,.64.29.64.64v2.01ZM116.04,61.89c0,.36-.29.64-.64.64h-10.01v-3.3h10.01c.36,0,.64.29.64.64v2.01Z","M213.59,55.94h-27.04c-1.26,0-2.28,1.02-2.28,2.28v11.93c0,1.26,1.02,2.28,2.28,2.28h27.04c1.26,0,2.28-1.02,2.28-2.28v-11.93c0-1.26-1.02-2.28-2.28-2.28M205.4,59.88v8.61c0,.36-.29.64-.64.64h-9.37c-.36,0-.64-.29-.64-.64v-8.61c0-.36.29-.64.64-.64h9.37c.36,0,.64.29.64.64"],"stroke":1.155,"ratio":0.0701155922886494},"raptor":{"label":"Raptor","vb":"-2.446 32.624 682.922 98.792","outer":["M84.66,73.68h6.74c10.91,0,19.84-6.78,19.84-15.76v-11.16c0-6.24-5.1-11.34-11.34-11.34H.35v59.83h34.33v-21.57h7.73c4.65.4,22.92,3.6,32.15,29.44,0,0,27.5,1.88,70,25.5-38.64-47.89-57.65-54.32-59.9-54.94ZM72.06,57.25h-37.38v-7.5h37.38v7.5Z","M617.79,73.68h6.74c10.91,0,19.84-6.78,19.84-15.76v-11.16c0-6.24-5.1-11.34-11.34-11.34h-99.56v59.83h34.33v-21.57h7.73c4.65.4,22.92,3.6,32.15,29.44,0,0,27.5,1.88,70,25.5-38.64-47.89-57.65-54.32-59.9-54.94ZM605.19,57.25h-37.38v-7.5h37.38v7.5Z","M312.16,35.42h-99.56v59.83h34.33v-21.57h56.72c10.91,0,19.84-6.78,19.84-15.76v-11.16c0-6.24-5.1-11.34-11.34-11.34ZM284.31,57.25h-37.38v-7.5h37.38v7.5Z","M428.14 35.42 L309.62 35.42 L309.62 48.9 L348.35 48.9 L348.35 95.25 L382.69 95.25 L382.69 48.9 L428.14 48.9 L428.14 35.42Z","M182.38,35.42h-38.85l-59.43,59.67h35.4l14.42-14.83h58.06l14.42,14.83h35.4l-59.43-59.67ZM151.6,62.08l11.36-11.69,11.36,11.69h-22.73Z","M518.77,35.42h-87.79v16.6h-22.12v33.14c0,5.46,4.46,9.92,9.92,9.92h99.99c5.46,0,9.92-4.46,9.92-9.92v-39.82c0-5.46-4.46-9.92-9.92-9.92ZM494.69,80.58h-51.84v-30.67h51.84v30.67Z"],"inner":["M84.66,73.68h6.74c10.91,0,19.84-6.78,19.84-15.76v-11.16c0-6.24-5.1-11.34-11.34-11.34H.35v59.83h34.33v-21.57h7.73c4.65.4,22.92,3.6,32.15,29.44,0,0,27.5,1.88,70,25.5-38.64-47.89-57.65-54.32-59.9-54.94ZM72.06,57.25h-37.38v-7.5h37.38v7.5Z","M617.79,73.68h6.74c10.91,0,19.84-6.78,19.84-15.76v-11.16c0-6.24-5.1-11.34-11.34-11.34h-99.56v59.83h34.33v-21.57h7.73c4.65.4,22.92,3.6,32.15,29.44,0,0,27.5,1.88,70,25.5-38.64-47.89-57.65-54.32-59.9-54.94ZM605.19,57.25h-37.38v-7.5h37.38v7.5Z","M312.16,35.42h-99.56v59.83h34.33v-21.57h56.72c10.91,0,19.84-6.78,19.84-15.76v-11.16c0-6.24-5.1-11.34-11.34-11.34ZM284.31,57.25h-37.38v-7.5h37.38v7.5Z","M428.14 35.42 L309.62 35.42 L309.62 48.9 L348.35 48.9 L348.35 95.25 L382.69 95.25 L382.69 48.9 L428.14 48.9 L428.14 35.42Z","M182.38,35.42h-38.85l-59.43,59.67h35.4l14.42-14.83h58.06l14.42,14.83h35.4l-59.43-59.67ZM151.6,62.08l11.36-11.69,11.36,11.69h-22.73Z","M518.77,35.42h-87.79v16.6h-22.12v33.14c0,5.46,4.46,9.92,9.92,9.92h99.99c5.46,0,9.92-4.46,9.92-9.92v-39.82c0-5.46-4.46-9.92-9.92-9.92ZM494.69,80.58h-51.84v-30.67h51.84v30.67Z"],"stroke":3.728,"ratio":0.1446607372437848},"ranger":{"label":"Ranger","vb":"-1.010 -1.010 285.460 24.460","outer":["M283.44,6.94v-3.15c0-2.03-1.66-3.68-3.69-3.68h-38.59v22.33h9.2v-9.28h23.81s0,9.28,0,9.28h9.27v-8.12c0-2.03-1.66-3.68-3.69-3.68,2.03,0,3.69-1.66,3.69-3.69ZM274.19,6.8c0,1.2-.98,2.18-2.18,2.18h-21.66v-4.37h21.66c1.2,0,2.18.98,2.18,2.18h0Z","M85.09,22.44h10.58S76.9.12,76.9.12h-6.59s-6.59,0-6.59,0l-18.77,22.32h10.58s4.37-5.21,4.37-5.21h20.8s4.37,5.2,4.37,5.2ZM63.42,13.06l6.89-8.2,6.89,8.2h-13.79Z","M179.44,17.92h-20.33c-1.56,0-2.83-1.28-2.83-2.83v-7.79c0-1.56,1.28-2.83,2.83-2.83h29.72V0h-36.79c-2.81,0-5.1,2.3-5.1,5.1v12.17c0,2.81,2.3,5.1,5.1,5.1h36.79v-13.4h-23.97v4.17s14.58,0,14.58,0v4.77Z","M38.59.1H0v22.33h9.2v-9.28h23.81s0,9.28,0,9.28h9.27v-8.12c0-2.03-1.66-3.68-3.68-3.68,2.03,0,3.68-1.66,3.68-3.69v-3.15c0-2.03-1.66-3.68-3.68-3.68ZM33.04,6.8c0,1.2-.98,2.18-2.18,2.18H9.19v-4.37h21.66c1.2,0,2.18.98,2.18,2.18h0Z","M130.96 14.35 L107.78 .08 L98.14 .08 L98.14 22.43 L107.4 22.43 L107.4 8.17 L130.57 22.43 L140.21 22.43 L140.21 .08 L130.96 .08 L130.96 14.35Z","M206.99,4.46h27.37V0h-34.16c-2.81,0-5.1,2.3-5.1,5.1v12.17c0,2.81,2.3,5.1,5.1,5.1h34.16v-4.46h-27.37c-1.09,0-1.98-.89-1.98-1.98v-2.78h29.35v-4.17h-29.35v-2.54c0-1.09.89-1.98,1.98-1.98Z"],"inner":["M283.44,6.94v-3.15c0-2.03-1.66-3.68-3.69-3.68h-38.59v22.33h9.2v-9.28h23.81s0,9.28,0,9.28h9.27v-8.12c0-2.03-1.66-3.68-3.69-3.68,2.03,0,3.69-1.66,3.69-3.69ZM274.19,6.8c0,1.2-.98,2.18-2.18,2.18h-21.66v-4.37h21.66c1.2,0,2.18.98,2.18,2.18h0Z","M85.09,22.44h10.58S76.9.12,76.9.12h-6.59s-6.59,0-6.59,0l-18.77,22.32h10.58s4.37-5.21,4.37-5.21h20.8s4.37,5.2,4.37,5.2ZM63.42,13.06l6.89-8.2,6.89,8.2h-13.79Z","M179.44,17.92h-20.33c-1.56,0-2.83-1.28-2.83-2.83v-7.79c0-1.56,1.28-2.83,2.83-2.83h29.72V0h-36.79c-2.81,0-5.1,2.3-5.1,5.1v12.17c0,2.81,2.3,5.1,5.1,5.1h36.79v-13.4h-23.97v4.17s14.58,0,14.58,0v4.77Z","M38.59.1H0v22.33h9.2v-9.28h23.81s0,9.28,0,9.28h9.27v-8.12c0-2.03-1.66-3.68-3.68-3.68,2.03,0,3.68-1.66,3.68-3.69v-3.15c0-2.03-1.66-3.68-3.68-3.68ZM33.04,6.8c0,1.2-.98,2.18-2.18,2.18H9.19v-4.37h21.66c1.2,0,2.18.98,2.18,2.18h0Z","M130.96 14.35 L107.78 .08 L98.14 .08 L98.14 22.43 L107.4 22.43 L107.4 8.17 L130.57 22.43 L140.21 22.43 L140.21 .08 L130.96 .08 L130.96 14.35Z","M206.99,4.46h27.37V0h-34.16c-2.81,0-5.1,2.3-5.1,5.1v12.17c0,2.81,2.3,5.1,5.1,5.1h34.16v-4.46h-27.37c-1.09,0-1.98-.89-1.98-1.98v-2.78h29.35v-4.17h-29.35v-2.54c0-1.09.89-1.98,1.98-1.98Z"],"stroke":1.571,"ratio":0.08568562018189603},"4x4":{"label":"4x4","vb":"-0.097 -0.098 49.324 10.035","outer":["M14.557.005c-.008-.001 0 0 0 0zM16.29 6.11c-.007-.46-.257-.55-.688-.55H6.965l3.817-2.184c.002.456.004 1.266-.001 1.403-.01.249.08.553.563.585.075.005.805.006 2.689.002h.461c.206 0 .368-.057.479-.168.153-.153.153-.352.153-.426L15.124.603c0-.385-.296-.579-.567-.598L11.053 0c-.361 0-.496.059-.721.171A4469.9 4469.9 0 0 0 .435 5.442c-.357.197-.417.423-.428.638l-.001.03c-.004.05 0 1.773-.004 1.863-.01.196.07.324.139.396.116.122.285.184.503.184l10.128.001v.699c0 .081 0 .27.146.416.148.148.363.167.535.167 0 0 3.017.006 3.103-.001.337-.023.547-.24.562-.578.006-.133.012-.478.005-.704h.559c.157 0 .335-.018.467-.149.146-.146.146-.34.146-.482-.003-.001-.004-1.79-.005-1.812z","M49.124 6.11c-.007-.46-.257-.55-.688-.55h-8.638l3.818-2.184c.001.456.004 1.266-.001 1.403-.01.249.079.553.562.585.076.005.805.006 2.69.002h.46c.207 0 .368-.057.479-.168.153-.153.153-.352.153-.426L47.957.603c0-.385-.296-.579-.567-.598L43.887 0c-.361 0-.496.059-.721.171-.171.086-9.607 5.111-9.898 5.271-.356.196-.416.423-.427.637l-.001.03c-.004.05 0 1.773-.004 1.863-.01.196.07.324.139.396.116.122.285.184.503.184l10.128.001v.699c0 .081 0 .27.146.416.148.148.364.167.535.167 0 0 3.017.006 3.103-.001.336-.023.546-.24.561-.578.006-.133.012-.478.005-.704h.559c.157 0 .334-.018.467-.149.146-.146.146-.34.146-.482-.003 0-.004-1.789-.004-1.811z","M17.641 2.206l4.505 3.197 3.052-1.759-3.13-2.206h-3.923c-.468.007-.703.01-.784.271-.076.245.121.385.28.497z","M33.265 2.263c.16-.09.401-.226.331-.494-.076-.292-.41-.292-.732-.292h-3.869s-11.532 7.075-12.107 7.42c-.177.106-.508.305-.421.613.083.292.412.29.608.288h3.932l12.258-7.535z","M32.978 8.932l-4.821-3.318-2.868 1.846 3.506 2.337s3.934.003 3.97.006c.203.015.51.037.607-.24.102-.295-.197-.498-.394-.631z"],"inner":["M15.67 7.931h-.593c-.153 0-.328.019-.454.151-.14.146-.13.343-.126.438.009.183.004.547-.002.694-.213.006-3.086.001-3.102 0v-.661c0-.456-.151-.607-.623-.622-.24-.007-10.135 0-10.146 0 .003-.161.004-1.837.008-1.87a.345.345 0 0 1 .103-.074c.276-.152 9.69-5.166 9.876-5.26.175-.087.211-.105.442-.105l3.45.003v4.118c-.006.001-2.865.006-3.099.001.004-.227 0-1.741 0-1.741a.379.379 0 0 0-.279-.377.493.493 0 0 0-.22-.002.318.318 0 0 0-.128.038.527.527 0 0 0-.149.087c-1.995 1.143-4.04 2.311-4.632 2.65-.187.112-.279.308-.23.486.028.11.134.307.495.307 0 0 9.409-.008 9.409 0 .008.198 0 1.733 0 1.739z","M48.503 7.931h-.593c-.153 0-.327.019-.454.151-.14.146-.13.343-.125.438.009.183.003.547-.002.694-.213.006-3.086.001-3.102 0v-.661c0-.456-.151-.607-.622-.622-.24-.007-10.135 0-10.146 0 .003-.161.004-1.837.008-1.87a.355.355 0 0 1 .103-.073c.276-.152 9.69-5.166 9.876-5.26.175-.087.211-.105.442-.105l3.449.003v4.118c-.006.001-2.865.006-3.099.001.004-.227 0-1.741 0-1.741a.38.38 0 0 0-.279-.377.493.493 0 0 0-.22-.002.327.327 0 0 0-.129.038.541.541 0 0 0-.149.087c-1.995 1.143-4.039 2.311-4.632 2.65-.187.112-.279.308-.23.486.031.11.136.308.498.308 0 0 9.408-.008 9.409 0 .005.196-.003 1.731-.003 1.737z","M21.869 2.059l2.174 1.533-1.863 1.073c-.607-.43-2.752-1.948-3.677-2.606.92-.004 2.904-.001 3.366 0z","M20.831 9.175h-3.203a12848.84 12848.84 0 0 0 11.543-7.076h3.164C30.1 3.47 21.792 8.584 20.831 9.175z","M26.424 7.469l1.721-1.108c.66.456 3.06 2.11 4.087 2.814h-3.248l-2.56-1.706z"],"stroke":0,"ratio":0.2034554913932193}};
const BADGE_FIT={f150:1,bronco:1,raptor:1,ranger:1,"4x4":1};
const BADGE_ORDER=["f150","bronco","raptor","ranger","4x4"];
const S={scol:"red",pack:"hood",side:"",saddtext:"no",stcol:"red",sduo:"one",stout:"black",ssc:1,sro:0,sx:0,sy:0,six:0,siy:0,sirot:0,siscale:1,year:"",model:"",trim:"",hood:"",hoodname:"",hoodOK:false,veh:"",mode:"",des:"",s1open:true,ix:0,iy:0,irot:0,iscale:1,focus:"text",badge:"",bx:0,by:0,brot:0,bscale:1,bout:"red",bin:"black",txtsrc:"type",txtduo:"one",tout:"black",
          border:"no",addtext:"no",bcol:"red",tcol:"red",tx:0,ty:0,rot:0,scale:1,
          main:"black",acc:"red",acc2:"white",touched:false};
const $=i=>document.getElementById(i);
const S0=JSON.parse(JSON.stringify(S));
// Ready designs <-> personalized: nothing carries over from one to the other. Only the vehicle
// (step 1) and what the customer is buying (hood / side / both) are kept.
function resetDesign(){
  const KEEP=["year","model","trim","hood","hoodname","hoodOK","veh","s1open","pack","mode"];
  Object.keys(S).forEach(k=>{ if(!KEEP.includes(k)&&!(k in S0)) delete S[k]; });
  Object.keys(S0).forEach(k=>{ if(!KEEP.includes(k)) S[k]=S0[k]; });
  ["ctext","cdesc","cfontother","stext","sfontother"].forEach(id=>{ const e=$(id); if(e) e.value=""; });
  ["cfont","sfont"].forEach(id=>{ const e=$(id); if(e) e.selectedIndex=0; });
  ["cfile","sfile"].forEach(id=>{ const e=$(id); if(e) try{ e.value=""; }catch(_){} });
  UIMG=null; SIMG=null;
  ["imgctl","sictl"].forEach(id=>{ const e=$(id); if(e) e.hidden=true; });
  [["csize",100],["crot",0],["isize",100],["irot",0],["sisize",100],["sirot",0],["ssize",100],["srot",0]]
    .forEach(([id,v])=>{ const e=$(id); if(e) e.value=v; });
  SEL=null;
  if(S.veh) applyDefaults();
}

function opts(host,items,key,sw,dis){
 if(sw && items.length>10){
   const cur=items.find(o=>o.id===S[key]);
   $(host).className="sw-grid";
   $(host).innerHTML=items.map(o=>{
     const bgv=o.cut?"repeating-linear-gradient(45deg,#bbb 0 4px,#fff 4px 8px)":o.hex;
     const d=dis&&dis(o)?" disabled":"";
     return `<button class="opt sw-btn" type="button"${d} title="${o.label}" data-k="${key}" `+
            `data-v="${o.id}" aria-pressed="${S[key]===o.id}"><span style="background:${bgv}"></span></button>`;
   }).join("")+`<div class="sw-name" style="width:100%">${cur?cur.label:""}</div>`+
     (S[key]==="other"?`<input type="text" class="othbox" data-ok="${key}" placeholder="Colour name or code, e.g. Nardo Grey or #6E7273" value="${(S[key+"_txt"]||"").replace(/"/g,"&quot;")}">`:"");
   return;
 }
 $(host).className="row";
 $(host).innerHTML=items.map(o=>{
  const inner = sw&&o.hex ? `<span class="sw"><span class="chip" style="background:${o.hex}"></span>${o.label}</span>`
    : o.cut ? `<span class="sw"><span class="chip cut"></span>${o.label}</span>` : o.label;
  const d = dis&&dis(o) ? " disabled" : "";
  return `<button class="opt" type="button"${d} data-k="${key}" data-v="${o.id}" aria-pressed="${S[key]===o.id}">${inner}</button>`;
 }).join("");
}
function fillSel(el,items,ph){
 el.innerHTML=`<option value="">${ph}</option>`+items.map(o=>
  `<option value="${o.id}">${o.label}</option>`).join("");
}

$("cfont").innerHTML=FONTS.map((f,i)=>`<option value="${f[0]}">${f[1]}</option>`).join("")+`<option value="__other">Other \u2014 type a font name</option>`;
$("cfile").addEventListener("change",e=>{
  const f=e.target.files&&e.target.files[0]; if(!f){UIMG=null;render();return;}
  if(!/^image\//.test(f.type)){UIMG=null;$("imgctl").hidden=true;render();return;}
  const rd=new FileReader(); rd.onload=()=>{const im=new Image(); im.onload=()=>{
    const c=document.createElement("canvas"); const k=Math.min(1,1200/Math.max(im.width,im.height));
    c.width=Math.round(im.width*k); c.height=Math.round(im.height*k); c.getContext("2d").drawImage(im,0,0,c.width,c.height);
    UIMG=c.toDataURL("image/png"); UIW=c.width; UIH=c.height; S.ix=0;S.iy=0;S.irot=0;S.iscale=1; render(); }; im.src=rd.result; }; rd.readAsDataURL(f);
});
$("isize").oninput=e=>{S.iscale=+e.target.value/100;S.focus="img";S.gfocus="hood";SEL="img";render();};
// ---- side decals: text and artwork, mirrored onto both panels ----
$("sfont").innerHTML=FONTS.map(f=>`<option value="${f[0]}">${f[1]}</option>`).join("")+`<option value="__other">Other \u2014 type a font name</option>`;
$("sfont").onchange=()=>{const o=$("sfont").value!=="__other";$("sfontother").hidden=o;$("sfonthint").hidden=o;render();};
$("sfontother").oninput=()=>render();
$("sfontother").onchange=()=>{loadWebFont($("sfontother").value);render();};
function sideFontValue(){
  if($("sfont").value!=="__other") return $("sfont").value;
  const f=($("sfontother").value||"").trim();
  if(!f) return "Impact, sans-serif";
  clearTimeout(_sfontTimer); _sfontTimer=setTimeout(()=>loadWebFont(f),450);
  return '"'+f.replace(/"/g,"")+'", Impact, sans-serif';
}
var _sfontTimer=null;
const sideFontName=()=>$("sfont").value==="__other"?(($("sfontother").value||"").trim()||"?"):$("sfont").selectedOptions[0].textContent.split(" \u2014")[0];
// ---- text colours, shared by the hood text and the side text ----
// fill and outline can each be a vinyl colour or a cut-out (bare paint), but not both cut out
function textLook(fillKey,outKey,duoKey){
  const f=pick(VIN,fillKey), o=pick(TOUT,outKey), two=S[duoKey]==="two";
  return {two, fillCut:!!(f&&f.cut), outCut:two&&!!(o&&o.cut),
          fill:(f&&!f.cut&&f.hex)||"#C8102E", out:(o&&!o.cut&&o.hex)||"#1C1C1C"};
}
const SVGNS="http://www.w3.org/2000/svg";
// The rotate / resize handles are drawn in viewBox units. A fingertip is a far
// blunter pointer than a mouse, so on touch screens they are drawn 25% larger,
// which grows the tap target as well as the icon.
const COARSE=!!(window.matchMedia&&window.matchMedia("(pointer:coarse)").matches);
// The Jeep builder's 248-unit viewBox covers ~57% of its preview; the Ford layers span
// 113% of theirs. HSPAN rescales so the handles come out the same on-screen size as the
// Jeep's (about 26 px with a mouse, 25 px on a phone), and the gaps around the art with them.
function HSPAN(){ const l=$("d_"+fam+"_text"); const m=l&&(l.getAttribute("style")||"").match(/width:\s*(-?[\d.]+)%/);
  const f=m?parseFloat(m[1])/100:0.573; return 0.573/(f||0.573); }
function gapK(vbw){ return ((vbw||248)/248)*HSPAN(); }
function handleK(vbw){ return gapK(vbw)*(COARSE?1.25:1); }
// Each handle carries an invisible circle that is what you actually grab. On a
// touch screen it is widened well past the icon, so the handle is easy to catch
// without the icon having to look oversized.
const HITR=COARSE?11:6.5;
function grabArea(g){ if(!g)return g; const c=g.querySelector("circle");
 if(c&&c.getAttribute("r")!=HITR) c.setAttribute("r",HITR); return g; }
// paint one visible text node. Modes: fill / both (outline + fill) / ring (coloured outline
// around cut-out letters) / none (letters cut out, nothing printed)
function paintText(t,L){
  const fs=+t.getAttribute("font-size")||10, sw=fs*0.16;
  ["mask","stroke","stroke-width","paint-order","fill-opacity"].forEach(a=>t.removeAttribute(a));
  t.setAttribute("stroke-linejoin","round");
  const mode=!L.two?(L.fillCut?"none":"fill"):(L.outCut?"fill":(L.fillCut?"ring":"both"));
  t.dataset.look=mode; t.dataset.fill=L.fill; t.dataset.out=L.out; t.dataset.sw=sw;
  if(mode==="fill") t.setAttribute("fill",L.fill);
  else if(mode==="both"){ t.setAttribute("fill",L.fill); t.setAttribute("stroke",L.out); t.setAttribute("stroke-width",sw); t.setAttribute("paint-order","stroke"); }
  else { t.setAttribute("fill","#fff"); t.setAttribute("fill-opacity","0"); }
  if(mode==="ring"){
    t.setAttribute("stroke",L.out); t.setAttribute("stroke-width",sw);
    // the half of the outline that falls on the letters is hidden: the letters are cut out
    const svg=t.ownerSVGElement, id="rm_"+svg.id+"_"+(t.getAttribute("class")||"t").split(" ").pop();
    let mk=svg.querySelector("mask#"+id);
    if(!mk){ mk=document.createElementNS(SVGNS,"mask"); mk.id=id; mk.setAttribute("maskUnits","userSpaceOnUse");
      ["x","y"].forEach(a=>mk.setAttribute(a,"-100000")); ["width","height"].forEach(a=>mk.setAttribute(a,"200000"));
      const r=document.createElementNS(SVGNS,"rect"); ["x","y"].forEach(a=>r.setAttribute(a,"-100000")); ["width","height"].forEach(a=>r.setAttribute(a,"200000")); r.setAttribute("fill","#fff");
      mk.appendChild(r); mk.appendChild(document.createElementNS(SVGNS,"text"));
      let d=svg.querySelector("defs"); if(!d){ d=document.createElementNS(SVGNS,"defs"); svg.insertBefore(d,svg.firstChild); }
      d.appendChild(mk); }
    const c=mk.querySelector("text");
    ["x","y","font-size","font-family","font-weight","text-anchor","dominant-baseline"].forEach(a=>{const v=t.getAttribute(a); if(v!==null) c.setAttribute(a,v); else c.removeAttribute(a);});
    c.setAttribute("fill","#000"); c.textContent=t.textContent;
    t.setAttribute("mask","url(#"+id+")");
  }
  t.style.pointerEvents=(mode==="none"||mode==="ring")?"bounding-box":"all";
  return mode;
}
// the knockout copy that cuts the letters (or their outline) out of the vinyl
function knockText(k,L,sw){
  k.removeAttribute("stroke"); k.removeAttribute("stroke-width");
  k.setAttribute("fill","#000");
  if(L.outCut){ k.setAttribute("stroke","#000"); k.setAttribute("stroke-width",sw); k.setAttribute("stroke-linejoin","round"); }
}
$("stext").oninput=()=>render();
$("ssize").oninput=e=>{S.ssc=+e.target.value/100;S.sfocus="t";S.gfocus="side";if(!SEL||SEL.indexOf("stext")) SEL="stext:L";render();};
$("srot").oninput=e=>{S.sro=+e.target.value;S.sfocus="t";S.gfocus="side";if(!SEL||SEL.indexOf("stext")) SEL="stext:L";render();};
$("stext").addEventListener("focus",()=>{S.sfocus="t";render();});
$("sisize").oninput=e=>{S.siscale=+e.target.value/100;S.sfocus="i";S.gfocus="side";if(!SEL||SEL.indexOf("simg")) SEL="simg:L";render();};
$("sirot").oninput=e=>{S.sirot=+e.target.value;S.sfocus="i";S.gfocus="side";if(!SEL||SEL.indexOf("simg")) SEL="simg:L";render();};
$("sfile").addEventListener("change",e=>{
  const f=e.target.files&&e.target.files[0]; if(!f||!/^image\//.test(f.type)){SIMG=null;render();return;}
  const rd=new FileReader(); rd.onload=()=>{const im=new Image(); im.onload=()=>{
    const c=document.createElement("canvas"); const k=Math.min(1,1200/Math.max(im.width,im.height));
    c.width=Math.round(im.width*k); c.height=Math.round(im.height*k); c.getContext("2d").drawImage(im,0,0,c.width,c.height);
    SIMG=c.toDataURL("image/png"); SIW=c.width; SIH=c.height; S.six=0;S.siy=0;S.sirot=0;S.siscale=1; S.sfocus="i"; render(); }; im.src=rd.result; }; rd.readAsDataURL(f);
});
// left panel = the customer's placement; right panel = its mirror image about the hood's
// centre line, turned the opposite way so it still reads correctly
function drawSideArt(){
  const sv=$("d_"+fam+"_sidetext"); if(!sv) return;
  const g=(FAM[fam]||{}).geoside||{x:96,y:180,cx:180,rot:-100,fs:11};
  const show=hasSide();
  const txt=show&&S.saddtext==="yes" ? ($("stext").value||"").trim() : "";
  const img=show&&S.mode==="custom"&&sideImgOK()&&SIMG;
  const SL=textLook("stcol","stout","sduo"), sfam=sideFontValue();
  // 0\u00b0 = the text reads along the panel, top to bottom (the way Sarya wants it placed first)
  const base=g.rot+180;
  const lx=g.x+S.sx, ly=g.y+S.sy, rx=2*g.cx-lx, rot=base+S.sro;
  [["stL",lx,rot],["stR",rx,-rot]].forEach(([c,x,r])=>{
    const t=sv.querySelector("."+c);
    t.textContent=txt; t.setAttribute("x",x); t.setAttribute("y",ly);
    t.setAttribute("font-size",g.fs*S.ssc); t.setAttribute("font-family",sfam); t.setAttribute("font-weight","700");
    t.setAttribute("transform",`rotate(${r} ${x} ${ly})`);
    paintText(t,SL);
  });
  // cut-outs on the side panels: the same two words, knocked out of every side design
  const cut=!!txt&&(SL.fillCut||SL.outCut);
  ORDERK.forEach(k=>{
    const el=$("d_"+fam+"_"+k); if(!el) return;
    const mk=el.querySelector('mask[id^="tk_"]'); if(!mk) return;
    let kg=mk.querySelector(".kside");
    if(!cut||(desOf(k)||{}).sec!=="side"){ if(kg) kg.textContent=""; return; }
    if(!kg){ kg=document.createElementNS(SVGNS,"g"); kg.setAttribute("class","kside"); mk.appendChild(kg); }
    if(kg.childNodes.length!==2){ kg.textContent=""; kg.appendChild(document.createElementNS(SVGNS,"text")); kg.appendChild(document.createElementNS(SVGNS,"text")); }
    [".stL",".stR"].forEach((c,i)=>{ const src=sv.querySelector(c), k2=kg.childNodes[i];
      ["x","y","font-size","font-family","font-weight","text-anchor","dominant-baseline","transform"].forEach(a=>{const v=src.getAttribute(a); if(v!==null) k2.setAttribute(a,v);});
      k2.textContent=txt; knockText(k2,SL,g.fs*S.ssc*0.16); });
  });
  // the artwork starts a little further down the panel than the text, so the two don't sit on top of each other
  const rr=g.rot*Math.PI/180, off=52;
  const ix=g.x-Math.cos(rr)*off+S.six, iy=g.y-Math.sin(rr)*off+S.siy, irx=2*g.cx-ix, w=30*S.siscale, h=SIW?w*SIH/SIW:0;
  [["siL",ix,base+S.sirot],["siR",irx,-(base+S.sirot)]].forEach(([c,x,r])=>{
    const im=sv.querySelector("."+c);
    if(img){ im.setAttribute("href",SIMG); im.setAttribute("width",w); im.setAttribute("height",h);
      im.setAttribute("x",x-w/2); im.setAttribute("y",iy-h/2); // the right-hand copy is a true reflection of the left one (flipped, not just turned)
      im.setAttribute("transform", c==="siR" ? `rotate(${r} ${x} ${iy}) translate(${2*x} 0) scale(-1 1)` : `rotate(${r} ${x} ${iy})`); im.removeAttribute("hidden"); }
    else { im.setAttribute("hidden",""); im.setAttribute("href",""); }
  });
  if(txt||img) sv.removeAttribute("hidden"); else sv.setAttribute("hidden","");
  $("stextblock").hidden=S.saddtext!=="yes";
  $("sictl").hidden=!img;
  $("ssizen").textContent=Math.round(S.ssc*100)+"%"; $("srotn").textContent=Math.round(S.sro)+"\u00b0";
  $("ssize").value=Math.round(S.ssc*100); $("srot").value=Math.round(S.sro);
  $("sisizen").textContent=Math.round(S.siscale*100)+"%"; $("sirotn").textContent=Math.round(S.sirot)+"\u00b0";
  $("sisize").value=Math.round(S.siscale*100); $("sirot").value=Math.round(S.sirot);
  // rotate / resize handles on the side text and the side picture (both panels, mirrored)
  const H=sideHandles(sv); if(!H) return;
  const vb=sv.getAttribute("viewBox").split(" ").map(Number), kk=handleK(vb[2]), gap=13*gapK(vb[2]);
  const rp=(cx,cy,dx,dy,deg)=>{const a=deg*Math.PI/180,c=Math.cos(a),s2=Math.sin(a); return [cx+dx*c-dy*s2, cy+dx*s2+dy*c];};
  const place=(w,show,cx,cy,bw,bh,deg)=>{
    H.querySelectorAll('.shg[data-w="'+w+'"]').forEach(gp=>{
      if(!show||SEL!==(w==="t"?"stext:":"simg:")+gp.dataset.sd){ gp.setAttribute("hidden",""); return; } gp.removeAttribute("hidden");
      let pr=rp(cx,cy,0,-(bh/2+gap),deg), ps=rp(cx,cy,bw/2+gap*9/13,bh/2,deg);
      if(gp.dataset.sd==="R"){ pr=[2*g.cx-pr[0],pr[1]]; ps=[2*g.cx-ps[0],ps[1]]; }
      grabArea(gp.querySelector(".shrot")).setAttribute("transform","translate("+pr[0]+","+pr[1]+") scale("+kk+")");
      grabArea(gp.querySelector(".shsize")).setAttribute("transform","translate("+ps[0]+","+ps[1]+") scale("+kk+")");
    });
  };
  let tb={width:0,height:0}; try{ if(txt) tb=sv.querySelector(".stL").getBBox(); }catch(e){}
  // like the hood: handles show on whichever one the customer is working on (text or picture)
  place("t",!!txt,lx,ly,tb.width,tb.height,rot);
  place("i",!!img,ix,iy,w,h,base+S.sirot);
}
// every rotate / resize handle lives in one overlay layer above all the artwork, so a picture
// can never sit on top of a handle. All these layers share the same viewBox and placement.
function hndLayer(){
  const id="d_"+fam+"_handles"; let ov=$(id); if(ov) return ov;
  const ref=$("d_"+fam+"_text"); if(!ref) return null;
  ov=document.createElementNS(SVGNS,"svg"); ov.id=id; ov.setAttribute("class","decal hndlayer");
  ["viewBox","preserveAspectRatio","style"].forEach(a=>{const v=ref.getAttribute(a); if(v!==null) ov.setAttribute(a,v);});
  ref.parentNode.appendChild(ov);
  [["text",".thandles"],["img",".ihandles"],["badge",".bhandles"]].forEach(([k,c])=>{
    const l=$("d_"+fam+"_"+k), h=l&&l.querySelector(c); if(h){ h.dataset.layer=k; ov.appendChild(h); } });
  return ov;
}
const HND=c=>{const ov=hndLayer(); return ov?ov.querySelector(c):null;};
function syncHandles(){
  const ov=hndLayer(); if(!ov) return;
  ov.removeAttribute("hidden");
  if(ov.parentNode.lastElementChild!==ov) ov.parentNode.appendChild(ov);
  ov.querySelectorAll("[data-layer]").forEach(h=>{ const l=$("d_"+fam+"_"+h.dataset.layer);
    h.style.display=(!l||l.hasAttribute("hidden"))?"none":""; });
}
// the four handle pairs (text left/right, picture left/right), copied from the hood text's handles
function sideHandles(sv){
  const ov=hndLayer(); if(!ov) return null;
  let H=ov.querySelector(".shandles"); if(H){ H.dataset.layer="sidetext"; return H; }
  const src=ov.querySelector(".thandles"); if(!src) return null;
  H=document.createElementNS(SVGNS,"g"); H.setAttribute("class","shandles");
  [["t","L"],["t","R"],["i","L"],["i","R"]].forEach(([w,sd])=>{
    const gp=document.createElementNS(SVGNS,"g"); gp.setAttribute("class","shg"); gp.dataset.w=w; gp.dataset.sd=sd;
    gp.innerHTML=src.innerHTML.replace('class="hrot"','class="shrot"').replace('class="hsize"','class="shsize"');
    gp.setAttribute("hidden",""); H.appendChild(gp);
  });
  H.dataset.layer="sidetext"; ov.appendChild(H);
  return H;
}
// ---- two fingers anywhere on the preview: pinch to resize, twist to rotate ----
// Works on the hood text, the popular-text badge, the hood artwork, and the side text /
// side artwork. The fingers can land anywhere on the preview: they act on whatever is
// selected, which is far easier to hit on a phone than the handles. Registered first and
// in the capture phase, so a pinch always wins over the one-finger drags below.
const DRAGCANCEL=[];
let GESTURING=false, GEST_N=0;
// The one item whose rotate / resize handles are showing. Nothing is selected until the
// customer touches an item; touching another moves the handles there; tapping an empty
// part of the preview hides them. Values: "text" | "badge" | "img" (hood) and
// "stext:L" | "stext:R" | "simg:L" | "simg:R" (the side copy that was touched).
let SEL=null;
(function(){
 const pts=new Map();            // touch / pen pointers currently down on the preview
 let gest=null, gestLock=false;
 const GKEY={text :{s:"scale"  ,r:"rot"  ,lo:0.4 ,hi:2.2},
             img  :{s:"iscale" ,r:"irot" ,lo:0.2 ,hi:2.5},
             badge:{s:"bscale" ,r:"brot" ,lo:0.25,hi:2.2},
             stext:{s:"ssc"    ,r:"sro"  ,lo:0.4 ,hi:2.2},
             simg :{s:"siscale",r:"sirot",lo:0.2 ,hi:2.5}};
 function gestTarget(){
   const vis=id=>{const n=$(id);return !!n&&!n.hasAttribute("hidden");};
   const pop=(S.txtsrc==="popular"&&S.badge);
   const hood=[], side=[];
   if(vis("d_"+fam+"_img"))            hood.push("img");
   if(pop&&vis("d_"+fam+"_badge"))     hood.push("badge");
   if(!pop&&vis("d_"+fam+"_text"))     hood.push("text");
   const sv=$("d_"+fam+"_sidetext");
   if(sv&&!sv.hasAttribute("hidden")){
     const tl=sv.querySelector(".stL"), il=sv.querySelector(".siL");
     if(tl&&tl.textContent) side.push("stext");
     if(il&&!il.hasAttribute("hidden")) side.push("simg"); }
   const sidePick=()=>{const w=S.sfocus==="i"?"simg":"stext"; return side.indexOf(w)>=0?w:side[0];};
   if(SEL){ const k=SEL.split(":")[0]; if(hood.indexOf(k)>=0||side.indexOf(k)>=0) return k; }
   if(S.gfocus==="side"&&side.length) return sidePick();
   if(hood.length) return hood.indexOf(S.focus)>=0?S.focus:hood[0];   // honour the selection on the hood
   return side.length?sidePick():null;
 }
 function gestStart(){
   const ids=Array.from(pts.keys()).slice(-2);
   if(ids.length<2) return;
   const k=gestTarget(); if(!k) return;
   const A=pts.get(ids[0]), B=pts.get(ids[1]), g=GKEY[k];
   DRAGCANCEL.forEach(f=>{try{f();}catch(e){}});   // a one-finger drag must not fight the pinch
   if(k==="stext"||k==="simg"){ S.gfocus="side"; S.sfocus=(k==="simg"?"i":"t");
     if(!SEL||SEL.split(":")[0]!==k) SEL=k+":L"; }
   else { S.gfocus="hood"; S.focus=k; SEL=k; }
   GEST_N++;
   gest={ids:ids,key:g,
         d0:Math.max(24,Math.hypot(B.x-A.x,B.y-A.y)),
         a0:Math.atan2(B.y-A.y,B.x-A.x)*180/Math.PI,
         sc0:S[g.s],rot0:S[g.r]};
   gestLock=true; GESTURING=true;   // no drag until every finger is lifted
   render();
 }
 function gestMove(){
   if(!gest) return false;
   const A=pts.get(gest.ids[0]), B=pts.get(gest.ids[1]);
   if(!A||!B) return false;
   const g=gest.key;
   const d=Math.hypot(B.x-A.x,B.y-A.y);
   S[g.s]=Math.min(g.hi,Math.max(g.lo,gest.sc0*d/gest.d0));
   const a=Math.atan2(B.y-A.y,B.x-A.x)*180/Math.PI;
   const turn=gest.rot0+(a-gest.a0);
   S[g.r]=Math.round(((turn+180)%360+360)%360-180);
   render();                        // also refreshes the size / rotation readouts and sliders
   return true;
 }
 document.addEventListener("pointerdown",ev=>{
   // only fingers and pens are tracked: a mouse can never make two points,
   // so tracking it could only ever leave a stale one behind
   if(ev.pointerType==="mouse") return;
   const T=ev.target; if(!(T&&T.closest&&T.closest(".hood-builder .stage"))) return;
   pts.set(ev.pointerId,{x:ev.clientX,y:ev.clientY});
   if(pts.size>=2){ gestStart(); if(gest){ ev.preventDefault(); ev.stopImmediatePropagation(); return; } }
   if(gestLock){ ev.preventDefault(); ev.stopImmediatePropagation(); }
 },true);
 document.addEventListener("pointermove",ev=>{
   if(pts.has(ev.pointerId)) pts.set(ev.pointerId,{x:ev.clientX,y:ev.clientY});
   if(gest&&gestMove()){ ev.preventDefault(); ev.stopImmediatePropagation(); return; }
   if(gestLock) ev.stopImmediatePropagation();
 },true);
 function liftPointer(ev){
   if(ev&&ev.pointerId!=null) pts.delete(ev.pointerId);
   if(gest&&pts.size<2) gest=null;                     // second finger gone: gesture is over
   if(pts.size===0){ gestLock=false; GESTURING=false; } // all fingers up: dragging allowed again
 }
 document.addEventListener("pointerup",liftPointer,true);
 // a tap on an empty part of the preview hides the handles
 let blank=null;
 const ITEM=".ctxt,.uimg,.bwrap,.stxt,.simg,.hrot,.hsize,.ihrot,.ihsize,.bhrot,.bhsize,.shrot,.shsize";
 document.addEventListener("pointerdown",ev=>{
   const T=ev.target; if(!(T&&T.closest&&T.closest(".hood-builder .stage"))||T.closest(ITEM)){ blank=null; return; }
   blank={id:ev.pointerId,x:ev.clientX,y:ev.clientY,n:GEST_N};
 },true);
 document.addEventListener("pointerup",ev=>{
   const b=blank; blank=null;
   if(!b||b.id!==ev.pointerId||b.n!==GEST_N||Math.hypot(ev.clientX-b.x,ev.clientY-b.y)>8) return;
   if(SEL!==null){ SEL=null; render(); }
 },true);
 document.addEventListener("pointercancel",liftPointer,true);
 window.addEventListener("blur",()=>{ pts.clear(); gest=null; gestLock=false; GESTURING=false; });
})();

// drag either copy; the other follows mirrored
(function(){
  let d=null;
  DRAGCANCEL.push(()=>{ d=null; });
  window.addEventListener("blur",()=>{ d=null; });
  ["pointerup","pointercancel"].forEach(t=>document.addEventListener(t,()=>{ d=null; }));
  document.addEventListener("pointerdown",ev=>{
    // the rotate / resize handles
    const hd=ev.target&&ev.target.closest&&ev.target.closest(".shrot,.shsize");
    if(hd){
      S.gfocus="side";
      const gp=hd.closest(".shg"), sv=$("d_"+fam+"_sidetext");
      SEL=(gp.dataset.w==="t"?"stext:":"simg:")+gp.dataset.sd;
      const tgt=sv.querySelector(gp.dataset.w==="t"?(gp.dataset.sd==="L"?".stL":".stR"):(gp.dataset.sd==="L"?".siL":".siR"));
      const b=tgt.getBoundingClientRect(), cx=b.left+b.width/2, cy=b.top+b.height/2;
      d={hand:hd.classList.contains("shrot")?"rot":"size", what:gp.dataset.w, right:gp.dataset.sd==="R", cx, cy,
         sc0:gp.dataset.w==="t"?S.ssc:S.siscale, d0:Math.max(1,Math.hypot(ev.clientX-cx,ev.clientY-cy))};
      try{ hd.setPointerCapture&&hd.setPointerCapture(ev.pointerId);}catch(e){}
      ev.preventDefault(); ev.stopPropagation(); return;
    }
    const el=ev.target&&ev.target.closest&&ev.target.closest(".stxt,.simg"); if(!el) return;
    S.gfocus="side";
    {const f=el.classList.contains("simg")?"i":"t";
     const ns=(f==="i"?"simg:":"stext:")+((el.classList.contains("stR")||el.classList.contains("siR"))?"R":"L");
     if(S.sfocus!==f||SEL!==ns){ S.sfocus=f; SEL=ns; render(); }}
    const sv=$("d_"+fam+"_sidetext"); const vb=sv.getAttribute("viewBox").split(" ").map(Number), r=sv.getBoundingClientRect();
    const right=el.classList.contains("stR")||el.classList.contains("siR"), isImg=el.classList.contains("simg");
    d={x:ev.clientX,y:ev.clientY,kx:vb[2]/r.width,ky:vb[3]/r.height,right,isImg,
       ox:isImg?S.six:S.sx, oy:isImg?S.siy:S.sy};
    try{ el.setPointerCapture&&el.setPointerCapture(ev.pointerId);}catch(e){}
    ev.preventDefault(); ev.stopPropagation();
  },true);
  document.addEventListener("pointermove",ev=>{
    if(!d) return; if(ev.buttons===0){d=null;return;}
    if(d.hand){
      const g=(FAM[fam]||{}).geoside||{rot:-100}, base=g.rot+180;
      if(d.hand==="rot"){
        const a=Math.atan2(ev.clientX-d.cx,-(ev.clientY-d.cy))*180/Math.PI;
        let off=(d.right?-a:a)-base; off=((off+540)%360)-180; off=Math.round(off);
        if(d.what==="t") S.sro=off; else S.sirot=off;
      } else {
        const k=d.sc0*Math.hypot(ev.clientX-d.cx,ev.clientY-d.cy)/d.d0;
        if(d.what==="t") S.ssc=Math.min(2.2,Math.max(0.4,k)); else S.siscale=Math.min(2.5,Math.max(0.2,k));
      }
      render(); return;
    }
    const dx=(ev.clientX-d.x)*d.kx*(d.right?-1:1), dy=(ev.clientY-d.y)*d.ky;
    if(d.isImg){S.six=d.ox+dx;S.siy=d.oy+dy;} else {S.sx=d.ox+dx;S.sy=d.oy+dy;}
    render();
  });
  ["pointerup","pointercancel"].forEach(t=>document.addEventListener(t,()=>{d=null;}));
})();
$("irot").oninput=e=>{S.irot=+e.target.value;S.focus="img";S.gfocus="hood";SEL="img";render();};
$("cfont").addEventListener("change",()=>{const o=$("cfont").value!=="__other";$("cfontother").hidden=o;$("fonthint").hidden=o;});
$("cfontother").oninput=()=>render();
$("cfontother").onchange=()=>{loadWebFont($("cfontother").value);render();};
let _fontTimer=null, _fontLoaded={};
function loadWebFont(name){
  const fam=String(name||"").trim(); if(!fam||_fontLoaded[fam]) return;
  _fontLoaded[fam]=1;
  const l=document.createElement("link"); l.rel="stylesheet";
  l.href="https://fonts.googleapis.com/css2?family="+encodeURIComponent(fam).replace(/%20/g,"+")+
         ":ital,wght@0,400;0,700;1,400&display=swap";
  l.onload=()=>render(); document.head.appendChild(l);
}
function fontValue(){
  if($("cfont").value!=="__other") return $("cfont").value;
  const fam=($("cfontother").value||"").trim();
  if(!fam) return "Impact, sans-serif";
  clearTimeout(_fontTimer); _fontTimer=setTimeout(()=>loadWebFont(fam),450);
  return '"'+fam.replace(/"/g,"")+'", Impact, sans-serif';
}
$("cfont").onchange=()=>render();
$("ctext").oninput=()=>render();
$("csize").oninput=e=>{S.gfocus="hood";SEL=(S.txtsrc==="popular"&&S.badge)?"badge":"text";const v=+e.target.value/100; if(S.txtsrc==="popular"&&S.badge)S.bscale=v; else S.scale=v; render();};
$("crot").oninput=e=>{S.gfocus="hood";SEL=(S.txtsrc==="popular"&&S.badge)?"badge":"text";const v=+e.target.value; if(S.txtsrc==="popular"&&S.badge)S.brot=v; else S.rot=v; render();};

// drag the text inside the preview
(function(){
 let drag=null, svg=null, t=null;
 let hdrag=null, _cap=null;
 function grab(ev){
   try{
     _cap=ev.currentTarget&&ev.currentTarget.setPointerCapture?ev.currentTarget:null;
     if(_cap&&ev.pointerId!=null) _cap.setPointerCapture(ev.pointerId);
   }catch(e){}
   ev.preventDefault();
 }
 function endDrag(){
   drag=null; hdrag=null;
   try{ if(_cap&&_cap.releasePointerCapture) _cap.releasePointerCapture(); }catch(e){}
   _cap=null;
 }
 DRAGCANCEL.push(endDrag);
 document.addEventListener("pointerdown",ev=>{
   const T=ev.target;
   const hit=sel=>(T&&T.closest)?T.closest(sel):null;
   if(hit(".hrot,.hsize,.ihrot,.ihsize,.bhrot,.bhsize,.uimg,.ctxt,.bwrap")){ S.gfocus="hood";
     const ns=hit(".ihrot,.ihsize,.uimg")?"img":hit(".bhrot,.bhsize,.bwrap")?"badge":"text";
     if(SEL!==ns){ SEL=ns; render(); } }
   // rotate / resize handles on the text
   if(hit(".hrot")||hit(".hsize")){
     const sv=$("d_"+fam+"_text"); const vbv=sv.getAttribute("viewBox").split(" ").map(Number); const r=sv.getBoundingClientRect();
     const tt=sv.querySelector(".ctxt");
     // measure from the same visual centre the rotate handle orbits, so grabbing it never jumps
     let dc=0; try{ dc=tt.getBBox().height*0.35*S.scale; }catch(e){}
     const a0=S.rot*Math.PI/180;
     const cx0=r.left+((+tt.getAttribute("x")+S.tx+Math.sin(a0)*dc)-vbv[0])/vbv[2]*r.width;
     const cy0=r.top +((+tt.getAttribute("y")+S.ty-Math.cos(a0)*dc)-vbv[1])/vbv[3]*r.height;
     hdrag={kind:hit(".hrot")?"rot":"size",cx:cx0,cy:cy0,rot0:S.rot,sc0:S.scale,
            d0:Math.hypot(ev.clientX-cx0,ev.clientY-cy0)};
     S.focus="text"; grab(ev); return;
   }
   // rotate / resize handles on the uploaded image
   if(hit(".bhrot")||hit(".bhsize")){
     const sv=$("d_"+fam+"_badge"); const vbv=sv.getAttribute("viewBox").split(" ").map(Number); const r=sv.getBoundingClientRect();
     const g=FAM[fam].geo;
     const cx0=r.left+((g.x+S.bx)-vbv[0])/vbv[2]*r.width;
     // the same centre the badge is drawn around (render: fullStage), or grabbing the turn handle flips it
     const cy0=r.top +((g.y-(vbv[2]>=1000?0:vbv[3]*0.24)+S.by)-vbv[1])/vbv[3]*r.height;
     hdrag={kind:hit(".bhrot")?"brot":"bsize",cx:cx0,cy:cy0,rot0:S.brot,sc0:S.bscale,
            d0:Math.hypot(ev.clientX-cx0,ev.clientY-cy0)};
     S.focus="badge"; grab(ev); return;
   }
   if(hit(".bwrap")){
     if(S.focus!=="badge"){ S.focus="badge"; render(); }
     const sv=$("d_"+fam+"_badge"); const vbv=sv.getAttribute("viewBox").split(" ").map(Number); const r=sv.getBoundingClientRect();
     hdrag={kind:"badge",x:ev.clientX,y:ev.clientY,ix:S.bx,iy:S.by,kx:vbv[2]/r.width,ky:vbv[3]/r.height};
     grab(ev); return;
   }
   if(hit(".ihrot")||hit(".ihsize")){
     const sv=$("d_"+fam+"_img"); const vbv=sv.getAttribute("viewBox").split(" ").map(Number); const r=sv.getBoundingClientRect();
     const g=FAM[fam].geo;
     const cx0=r.left+((g.x+S.ix)-vbv[0])/vbv[2]*r.width;
     const cy0=r.top +((g.y-vbv[3]*0.12+S.iy)-vbv[1])/vbv[3]*r.height;
     hdrag={kind:hit(".ihrot")?"irot":"isize",cx:cx0,cy:cy0,rot0:S.irot,sc0:S.iscale,
            d0:Math.hypot(ev.clientX-cx0,ev.clientY-cy0)};
     S.focus="img"; grab(ev); return;
   }
   // dragging the artwork itself
   if(hit(".uimg")){
     if(S.focus!=="img"){ S.focus="img"; render(); }
     const sv=$("d_"+fam+"_img"); const vbv=sv.getAttribute("viewBox").split(" ").map(Number); const r=sv.getBoundingClientRect();
     hdrag={kind:"img",x:ev.clientX,y:ev.clientY,ix:S.ix,iy:S.iy,kx:vbv[2]/r.width,ky:vbv[3]/r.height};
     grab(ev); return;
   }
   // dragging the text
   if(!hit(".ctxt")) return;
   if(S.focus!=="text"){ S.focus="text"; render(); }
   svg=$("d_"+fam+"_text"); t=svg.querySelector(".ctxt");
   const vb=svg.getAttribute("viewBox").split(" ").map(Number), r=svg.getBoundingClientRect();
   drag={x:ev.clientX,y:ev.clientY,tx:S.tx,ty:S.ty,kx:vb[2]/r.width,ky:vb[3]/r.height};
   grab(ev);
 });
 document.addEventListener("pointermove",ev=>{
   if((drag||hdrag) && ev.buttons===0){ endDrag(); return; }
   if(hdrag){
     if(hdrag.kind==="badge"){ S.bx=hdrag.ix+(ev.clientX-hdrag.x)*hdrag.kx; S.by=hdrag.iy+(ev.clientY-hdrag.y)*hdrag.ky; render(); return; }
     if(hdrag.kind==="brot"){ S.brot=Math.round(Math.atan2(ev.clientX-hdrag.cx,-(ev.clientY-hdrag.cy))*180/Math.PI); render(); return; }
     if(hdrag.kind==="bsize"){ const dd=Math.hypot(ev.clientX-hdrag.cx,ev.clientY-hdrag.cy);
       S.bscale=Math.min(2.2,Math.max(0.25,hdrag.sc0*dd/Math.max(hdrag.d0,1))); render(); return; }
     if(hdrag.kind==="irot"){ S.irot=Math.round(Math.atan2(ev.clientX-hdrag.cx,-(ev.clientY-hdrag.cy))*180/Math.PI); render(); return; }
     if(hdrag.kind==="isize"){ const dd=Math.hypot(ev.clientX-hdrag.cx,ev.clientY-hdrag.cy);
       S.iscale=Math.min(2.5,Math.max(0.2,hdrag.sc0*dd/Math.max(hdrag.d0,1))); render(); return; }
     if(hdrag.kind==="img"){ S.ix=hdrag.ix+(ev.clientX-hdrag.x)*hdrag.kx; S.iy=hdrag.iy+(ev.clientY-hdrag.y)*hdrag.ky; render(); return; }
     if(hdrag.kind==="rot"){ S.rot=Math.round(Math.atan2(ev.clientX-hdrag.cx, -(ev.clientY-hdrag.cy))*180/Math.PI); }
     else { const d=Math.hypot(ev.clientX-hdrag.cx,ev.clientY-hdrag.cy); S.scale=Math.min(2.2,Math.max(0.4,hdrag.sc0*d/Math.max(hdrag.d0,1))); }
     render(); return;
   }
   if(!drag)return;
   S.tx=drag.tx+(ev.clientX-drag.x)*drag.kx;
   S.ty=drag.ty+(ev.clientY-drag.y)*drag.ky;
   render();
 });
 const stop=endDrag;
 document.addEventListener("pointerup",stop);
 document.addEventListener("pointercancel",stop);
 // only ends a one-finger drag: must not disturb a running pinch
 document.addEventListener("lostpointercapture",()=>{ if(!GESTURING) endDrag(); });
 window.addEventListener("blur",stop);
 // a native image drag would swallow pointerup and leave the page stuck
 document.addEventListener("dragstart",e=>{ if(e.target.closest&&e.target.closest(".hood-builder")) e.preventDefault(); });
})();

// ---- step 1 ----
const years=Object.keys(D.fit.years).sort();
fillSel($("year"),years.map(y=>({id:y,label:y})),"Select year");
$("year").onchange=e=>{S.year=e.target.value;S.model="";S.trim="";resetHood();
 if(S.year){const ms=D.fit.years[S.year].map(m=>({id:m,label:D.fit.models[m].label}));
  fillSel($("model"),ms,"Select model");$("g-model").hidden=false;}
 else $("g-model").hidden=true;
 $("g-trim").hidden=true;render();};
function pickFam(){
 const nf=famFor(S.model,S.hood)||"f13";
 if(nf!==fam){fam=nf;S.des="";S.side="";S.tx=0;S.ty=0; if(!(VEHSETS[fam]||[]).includes(S.veh)) S.veh="";}
 loadFam(fam).then(()=>{ORDERK=(FAM[fam]||{}).order||[]; document.querySelectorAll(".veh").forEach(v=>v.hidden=(v.dataset.fam!==fam)); render();});
}
$("model").onchange=e=>{S.model=e.target.value;S.trim="";resetHood();pickFam();
 if(S.model){const y=+S.year;
  const inYear=t=>t.r ? t.r.some(([a,b])=>y>=a&&y<=b) : (t.from<=y);
  const ts=D.fit.trims[S.model].filter(inYear).map(t=>({id:t.id,label:t.label}))
            .concat([{id:"__other",label:"Other / not listed"}]);
  fillSel($("trim"),ts,"Select trim");$("g-trim").hidden=false;}
 else $("g-trim").hidden=true;
 render();};
$("s1sum").onclick=()=>{S.s1open=!S.s1open;render();};
$("s1next").onclick=()=>{S.s1open=false;render();const el=$("s4")||$("steps");if(el&&el.scrollIntoView)el.scrollIntoView({behavior:"smooth",block:"start"});};
$("trim").onchange=e=>{S.trim=e.target.value;resetHood();S.s1open=true;
 if(S.trim==="__other"){ $("hoodwrap").hidden=false; S.hood=""; S.hoodname=""; drawHoods();
   $("hoodconfirm").hidden=true; $("hoodpick").hidden=false; }
 if(S.trim){const g=guessHood();S.hood=g.id;$("hoodguess").textContent=g.label;}
 pickFam(); render();};

// ---- step 2 ----
function guessHood(){
 const hs=D.hoods[S.model]||[];
 const rec=(D.fit.trims[S.model]||[]).find(t=>t.id===S.trim);
 let id=rec&&rec.hood ? rec.hood : "std";
 if(!hs.find(h=>h[0]===id)) id="std";
 const h=hs.find(x=>x[0]===id)||hs[0]||["std","Standard Hood"];
 return {id:h[0],label:h[1]};
}
function resetHood(){S.hoodOK=false;S.hoodname="";$("hoodconfirm").hidden=false;
 $("hoodpick").hidden=true;$("hooddone").hidden=true;}
$("hoodyes").onclick=()=>{S.hoodOK=true;$("hoodconfirm").hidden=true;$("hooddone").hidden=false;
 S.hoodname=guessHood().label;$("hoodlabel").textContent=S.hoodname;render();};
const HOODFAM={f150:{std13:"f13",std14:"f14"},lightning:{lightning:"light"},f150raptor:{raptor:"raptor"},bronco:{bronco:"bronco"},broncoraptor:{broncoR:"broncoR"}};
const HOODTHUMB={};["f13","f14","light","raptor","bronco","broncoR"].forEach(k=>{HOODTHUMB[k]=(ASSETS[k]&&ASSETS[k].thumb)||"";});
function famFor(model,hood){return (HOODFAM[model]||{})[hood]||"f13";}
function showFam(f){loadFam(f).then(()=>{document.querySelectorAll(".veh").forEach(v=>v.hidden=(v.dataset.fam!==f));});}
function drawHoods(){
 $("g-hood").innerHTML=(D.hoods[S.model]||[]).map(h=>
  `<button class="hood" type="button" data-k="hood" data-v="${h[0]}" aria-pressed="${S.hood===h[0]}">`+
  `<img src="${HOODTHUMB[famFor(S.model,h[0])]}" alt=""><span>${h[1]}</span></button>`).join("");
}
document.addEventListener("mouseover",e=>{const b=e.target.closest("button.hood"); if(!b||S.hoodOK) return; showFam(famFor(S.model,b.dataset.v));});
document.addEventListener("mouseout",e=>{const b=e.target.closest("button.hood"); if(!b||S.hoodOK) return; showFam(famFor(S.model,S.hood));});
$("hoodno").onclick=()=>{$("hoodconfirm").hidden=true;$("hoodpick").hidden=false;
 drawHoods();render();};
$("hoodconfirm2").onclick=()=>{if(!S.hood)return;S.hoodOK=true;$("hoodpick").hidden=true;
 $("hooddone").hidden=false;
 const h=(D.hoods[S.model]||[]).find(x=>x[0]===S.hood);
 S.hoodname=h?h[1]:S.hood;$("hoodlabel").textContent=S.hoodname;render();};
$("hoodreset").onclick=()=>{resetHood();S.s1open=true;
 if(S.trim){const g=guessHood();S.hood=g.id;$("hoodguess").textContent=g.label;}
 pickFam(); render();};

// ---- defaults driven by vehicle colour ----
function applyDefaults(){
 if(S.veh==="black"){S.main="red";S.acc="white";S.bcol="red";S.tcol="white";S.acc2="black";}
 else {S.main="black";S.acc="red";S.bcol="red";S.tcol="red";S.acc2="white";}
}

// ---------------------------------------------------------------
// snapshot: redraw what the customer sees onto a canvas, so the
// finished preview can travel with the order as a real image
// ---------------------------------------------------------------
function loadImg(src){
  return new Promise((res,rej)=>{
    const i=new Image(); i.crossOrigin="anonymous";
    i.onload=()=>res(i); i.onerror=rej; i.src=src;
  });
}
function svgToImg(el,w,h){
  const c=el.cloneNode(true);
  c.removeAttribute("hidden"); c.removeAttribute("style");
  c.setAttribute("width",w); c.setAttribute("height",h);
  c.querySelectorAll(".thandles,.ihandles,.bhandles,.shandles").forEach(n=>n.remove());
  // the lighting filter lives outside this svg; drop it so the order image renders flat
  c.querySelectorAll("[filter]").forEach(n=>n.removeAttribute("filter"));
  // css variables do not survive serialisation, so bake the colours in
  const cs=getComputedStyle(document.documentElement);
  const V=k=>(cs.getPropertyValue(k).trim()||"#000");
  const main=V("--main"), acc=V("--acc"), bcol=V("--bcol"), tcol=V("--tcol"), scol=V("--scol");
  const st=document.createElementNS("http://www.w3.org/2000/svg","style");
  st.textContent=
    ".outer{fill:"+main+";stroke:"+main+";stroke-width:.9;stroke-linejoin:round}"+
    ".decal.b-on .outer,svg.b-on .outer{fill:"+bcol+";stroke:"+bcol+";stroke-width:.8;stroke-linejoin:round}"+
    ".decal.b-acc .outer,svg.b-acc .outer{fill:"+acc+";stroke:"+acc+";stroke-width:.8;stroke-linejoin:round}"+
    ".pn{fill:"+main+";stroke:"+main+";stroke-width:.15;stroke-linejoin:round}"+
    ".gf{fill:"+acc+"}.gs{fill:none;stroke:"+acc+"}.cutp{fill:"+main+"}"+
    ".gf2{fill:"+V("--acc2")+"}.gs2{fill:none;stroke:"+V("--acc2")+"}svg.g2 .gf{fill:"+V("--acc2")+"}svg.g2 .gs{stroke:"+V("--acc2")+"}"+
    ".bk{fill:"+acc+"}.sd{fill:"+scol+"}.sds{fill:none;stroke:"+scol+"}"+
    // on these the artwork is the second colour and the panel behind it is the main one
    "svg.inv .pn{fill:"+acc+";stroke:"+acc+"}svg.inv .gf{fill:"+main+"}"+
    "svg.inv .gs{stroke:"+main+"}svg.inv .bk{fill:"+main+"}svg.inv .cutp{fill:"+acc+"}"+
    "svg.inv.acc-cut .pn{fill:"+main+";stroke:"+main+"}svg.inv.acc-cut .gf{fill:"+acc+"}"+
    "svg.inv.acc-cut .gs{stroke:"+acc+"}svg.inv.acc-cut .bk{fill:"+acc+"}svg.inv.acc-cut .cutp{fill:"+main+"}"+
    "svg.edgefill:not(.b-on):not(.b-acc) .outer{display:none}svg.edgefill.b-on .ef,svg.edgefill.b-acc .ef{display:none}.ef{stroke:none}"+
    ".solid{display:inline}.cutp{display:none}.rim{display:none}";
  c.insertBefore(st,c.firstChild);
  let s=new XMLSerializer().serializeToString(c);
  ["--main","--acc","--acc2","--bcol","--tcol","--veh","--scol"].forEach(v=>{ s=s.split("var("+v+")").join(V(v)); });
  if(!/xmlns=/.test(s)) s=s.replace("<svg",'<svg xmlns="http://www.w3.org/2000/svg"');
  return loadImg("data:image/svg+xml;charset=utf-8,"+encodeURIComponent(s));
}
function boxOf(el,N){
  const st=el.getAttribute("style")||"";
  const n=k=>{const m=st.match(new RegExp(k+":(-?[\\d.]+)%")); return m?parseFloat(m[1])/100*N:0;};
  return {x:n("left"),y:n("top"),w:n("width"),h:n("height")};
}
async function drawHood(ctx,N){
  const A=ASSETS[fam]||{};
  const cs0=getComputedStyle(document.documentElement);
  if(!A.base){ ctx.fillStyle=(cs0.getPropertyValue("--veh").trim()||"#f2f2f2"); ctx.fillRect(0,0,N,N); }
  else{
  const [base,shade,spec,mask]=await Promise.all([A.base,A.shade,A.spec,A.mask].map(loadImg));
  ctx.drawImage(base,0,0,N,N);
  // paint = colour x shade, lifted by spec, limited to the mask
  const p=document.createElement("canvas"); p.width=p.height=N;
  const pc=p.getContext("2d");
  const cs=getComputedStyle(document.documentElement);
  pc.fillStyle=(cs.getPropertyValue("--veh").trim()||"#f2f2f2"); pc.fillRect(0,0,N,N);
  pc.globalCompositeOperation="multiply"; pc.drawImage(shade,0,0,N,N);
  pc.globalCompositeOperation="screen";   pc.drawImage(spec,0,0,N,N);
  pc.globalCompositeOperation="destination-in"; pc.drawImage(mask,0,0,N,N);
  ctx.drawImage(p,0,0); }
  // every visible decal layer, in the order the page stacks them
  const veh=document.querySelector('.veh[data-fam="'+fam+'"]');
  if(!veh) return;
  const layers=[...veh.querySelectorAll("svg.decal")].filter(e=>!e.hasAttribute("hidden"));
  // decals go on their own sheet first, so the body mask can trim them off the cowl
  const ctxMain=ctx;
  const dcv=document.createElement("canvas"); dcv.width=dcv.height=N;
  ctx=dcv.getContext("2d");
  for(const el of layers){
    const b=boxOf(el,N);
    if(!b.w||!b.h) continue;
    if(/_text$/.test(el.id)) continue;           // drawn below, so the real font is used
    try{ const im=await svgToImg(el,Math.round(b.w),Math.round(b.h));
         ctx.drawImage(im,b.x,b.y,b.w,b.h); }catch(e){}
  }
  const tl=veh.querySelector('svg[id$="_text"]:not([hidden])');
  if(tl){
    const t=tl.querySelector(".ctxt");
    const txt=t&&t.textContent;
    if(txt){
      const b=boxOf(tl,N);
      const vb=tl.getAttribute("viewBox").split(" ").map(Number);
      const kx=b.w/vb[2], ky=b.h/vb[3];
      const bx=+t.getAttribute("x"), by=+t.getAttribute("y");
      const fs=+t.getAttribute("font-size");
      const fam2=t.getAttribute("font-family")||"Impact, sans-serif";
      const cstt=getComputedStyle(t);
      ctx.save();
      ctx.translate(b.x,b.y); ctx.scale(kx,ky);
      ctx.translate(-vb[0],-vb[1]);      // the viewBox origin is not 0,0
      ctx.translate(S.tx,S.ty);
      ctx.translate(bx,by); ctx.rotate(S.rot*Math.PI/180); ctx.scale(S.scale,S.scale);
      ctx.textAlign="center"; ctx.textBaseline="alphabetic";
      const fw=(cstt.fontWeight||t.getAttribute("font-weight")||"400");
      ctx.font=fw+" "+fs+"px "+fam2;
      // same looks as the preview: fill / outline+fill / outline around cut letters / cut only
      const look=t.dataset.look||"fill", sw=+(t.dataset.sw||0);
      ctx.lineJoin="round";
      if(look==="both"||look==="ring"){ ctx.strokeStyle=t.dataset.out; ctx.lineWidth=sw; ctx.strokeText(txt,0,0); }
      if(look==="both"||look==="fill"){ ctx.fillStyle=t.dataset.fill; ctx.fillText(txt,0,0); }
      if(look==="ring"){ ctx.globalCompositeOperation="destination-out"; ctx.fillStyle="#000"; ctx.fillText(txt,0,0); ctx.globalCompositeOperation="source-over"; }
      ctx.restore();
    }
  }
  if(A.mask){ try{ const mk=await loadImg(A.mask); ctx.globalCompositeOperation="destination-in"; ctx.drawImage(mk,0,0,N,N); }catch(e){} }
  ctxMain.drawImage(dcv,0,0);
}
async function snapshot(){
  const N=1000;
  const cv=document.createElement("canvas");
  cv.width=N; cv.height=N;
  const ctx=cv.getContext("2d");
  ctx.fillStyle="#0d0f11"; ctx.fillRect(0,0,cv.width,cv.height);
  await drawHood(ctx,N);
  return new Promise(res=>cv.toBlob(b=>res(b),"image/png"));
}

// what the customer is buying: the hood decal, the pair of hood-side decals, or both
// ready designs: hood $100, sides $100, both $180. Personalised: $150, $150, $250.
const PRICE0={library:{hood:100,side:100,both:180},custom:{hood:150,side:150,both:250}};
// a truck can carry its own prices (2021+ F-150: side decals $75, added to any hood decal at $75, no discount);
// those orders use their own Shopify variants, named with the truck's prefix
const prices=()=>((FAM[fam]||{}).price)||PRICE0;
// 2021+ F-150: no personalised side decals. A personalised hood can take ready side decals
// from the library (+$75), and their text is charged like on ready designs
const libSides=()=>!!((FAM[fam]||{}).customSideLib);
function packs(){
  const cus=S.mode==="custom", P=prices()[cus?"custom":"library"];
  const L=prices().library, add=P.both-P.hood, save=P.hood+((cus&&libSides())?L.side:P.side)-P.both;
  const all=[{id:"hood",label:"Hood decal \u2014 $"+P.hood},
          {id:"side",label:"Hood side decals \u2014 $"+P.side},
          {id:"both",label:"Hood + side decals \u2014 $"+P.both+(save>0?" (save $"+save+")":" (side decals +$"+add+")")}];
  if((FAM[fam]||{}).noSide) return all.filter(o=>o.id==="hood");
  return (cus&&libSides()) ? all.filter(o=>o.id!=="side") : all;
}
const PACKS=[{id:"hood",label:"Hood decal"},{id:"side",label:"Hood side decals"},{id:"both",label:"Hood + side decals"}];
const hasHood=()=>S.pack==="hood"||S.pack==="both";
// designs drawn in two graphic colours (Bronco Raptor: red + white) get a second colour choice
// Bronco: a front decal and a lower part drawn in different graphic colours (white front, red flames)
// keep their own colours: the lower part's graphics take the 2nd graphics colour
const pairTwo=()=>{ const F=FAM[fam]||{}, t=F.two||{}, gc=F.gcol||{};
  return !!F.splitGfx && S.mode==="library" && hasHood() && hasSide() && !!S.des && !!S.side &&
    !t[S.des] && !t[S.side] && !!gc[S.des] && !!gc[S.side] && gc[S.des]!==gc[S.side]; };
const hasTwo=()=>{ const t=((FAM[fam]||{}).two||{});
  return S.mode==="library" && ((hasHood()&&!!S.des&&!!t[S.des]) || (hasSide()&&!!S.side&&!!t[S.side]) || pairTwo()); };
// a ready design with no graphics at all (Bronco Raptor #01 plain, #61) has no graphics colour to pick
function noGfx(){
  if(!(hasHood()&&S.mode==="library"&&S.des)) return false;
  if(hasSide()&&((FAM[fam]||{}).sideAcc||S.side)){
    // side layers drawn like hood layers (main vinyl + graphics): look at both
    const sl=S.side&&document.getElementById("d_"+fam+"_"+S.side);
    if(!sl||!sl.querySelector(".pn")||sl.querySelector(".gf,.gs,.gf2,.gs2,.bk")||(FAM[fam]||{}).sideAcc) return false;
  }
  const F=FAM[fam]||{}; if((F.lock&&F.lock[S.des])||(F.inv&&F.inv[S.des])) return false;
  if((F.plain||[]).includes(S.des)) return true;
  const lay=document.getElementById("d_"+fam+"_"+S.des); if(!lay) return false;
  return !lay.querySelector(".gf,.gs,.gf2,.gs2,.bk");
}
const hasSide=()=>S.pack==="side"||S.pack==="both";
// complete sets: a hood design and the side / lower design drawn with it on the same sheet
const setSides=id=>(((FAM[fam]||{}).match||{})[id])||[];
function setFront(sid){ const m=(FAM[fam]||{}).match||{}; let best=null;
  for(const h in m){ const i=m[h].indexOf(sid); if(i===0) return h; if(i>0&&!best) best=h; } return best; }
const nounSide=()=>((FAM[fam]||{}).sideNoun)||"hood side decals";
const nounHood=()=>((FAM[fam]||{}).hoodNoun)||"hood decal";
const STAR='<span class="setstar" title="Comes as a complete set">\u2605</span>';
const desList=sec=>((FAM[fam]||{}).designs||[]).filter(d=>(d.sec||"hood")===sec);
const desOf=id=>((FAM[fam]||{}).designs||[]).find(d=>d.id===id);
// text: one part $20, both parts $30 (included on personalised designs)
const hText=()=>hasHood()&&S.mode==="library"&&S.addtext==="yes";
const sText=()=>hasSide()&&(S.mode==="library"||libSides())&&S.saddtext==="yes";
function quote(){
  const pk=S.pack||"hood";
  if(S.mode==="custom") return prices().custom[pk]+(sText()?20:0);
  const t=(hText()?1:0)+(sText()?1:0);
  return prices().library[pk]+(t===2?30:t===1?20:0);
}
function cfgKey(){
  const k=cfgKey0(), pre=((FAM[fam]||{}).vprefix)||"";
  // hood-only orders cost the same on every truck and share the same variants
  return (pre && !/^hood/.test(k)) ? pre+k : k;
}
function cfgKey0(){
  const pk=S.pack||"hood";
  if(S.mode==="custom") return pk+"_custom"+(sText()?"_stext":"");
  const h=hText(), sd=sText();
  if(pk==="hood") return h?"hood_text":"hood";
  if(pk==="side") return sd?"side_text":"side";
  return h&&sd?"both_text2":h?"both_htext":sd?"both_stext":"both";
}
function syncCart(price){
  try{
    const V=window.__HOOD_VARIANTS__||{};
    const vid=V[cfgKey()];
    // the theme renders more than one /cart/add form (payment terms, dynamic checkout).
    // the real one is the form that owns the "Add to cart" submit button.
    const forms=[...document.querySelectorAll('form[action*="/cart/add"]')];
    const form=forms.find(f=>f.querySelector('[name="add"]'))||forms[forms.length-1];
    if(!form) return;
    if(vid){
      let idIn=form.querySelector('input[name="id"], select[name="id"]');
      // Dawn disables this input when the default variant looks unavailable
      if(idIn) idIn.removeAttribute("disabled");
      if(!idIn){ idIn=document.createElement("input"); idIn.type="hidden"; idIn.name="id"; form.appendChild(idIn); }
      idIn.value=vid;
    }
    // the customer's choices travel with the line item
    const props={
      "Vehicle": [S.year,(D.fit.models[S.model]||{}).label,trimLabel()].filter(Boolean).join(" \u00b7 "),
      "Hood": S.hoodname||"",
      "Vehicle colour": colName("veh"),
      "Order": (PACKS.find(p=>p.id===S.pack)||{label:""}).label.split(" \u2014")[0],
      "Hood decal design": !hasHood()?"":(S.mode==="custom"?"Personalized design":(S.des?((desOf(S.des)||{}).label||""):"")),
      "Hood side decal design": hasSide()&&S.side?((desOf(S.side)||{}).label||""):"",
      "Vinyl colour": (FAM[fam]&&FAM[fam].sideMono&&!hasHood())?"":colName("main"),
      [hasTwo()?"1st graphics colour":"Graphics colour"]: ((FAM[fam]&&FAM[fam].sideMono&&!hasHood()&&!FAM[fam].sideAcc)||noGfx())?"":colName("acc"),
      "2nd graphics colour": hasTwo()?colName("acc2"):"",
      "Side decal colour": (FAM[fam]&&FAM[fam].sideMono&&hasSide())?colName("scol"):"",
      "Border": !hasHood()?"":((S.mode!=="custom"&&FAM[fam]&&FAM[fam].lock&&FAM[fam].lock[S.des])?"Built into design (graphics colour)":(S.border==="yes"?("Yes \u2014 "+colName("bcol")):"No")),
      "Text": !hasHood()?"":(S.addtext==="yes"||S.mode==="custom")?(S.txtsrc==="popular"?(S.badge?("Popular: "+((BADGES[S.badge]||{}).label||S.badge)):""):($("ctext")?$("ctext").value:"")):"",
      "Your description": ($("cdesc")&&$("cdesc").value.trim())||"",
      "Side decal text": (hasSide()&&S.saddtext==="yes")?(($("stext").value||"").trim()):"",
      "Side text style": (hasSide()&&S.saddtext==="yes"&&($("stext").value||"").trim())
          ? (sideFontName()+" \u00b7 "+(S.sduo==="two"?(colName("stout")+" outline + "+colName("stcol")+" fill"):colName("stcol"))+" \u00b7 "+Math.round(S.ssc*100)+"% \u00b7 "+Math.round(S.sro)+"\u00b0 \u00b7 mirrored both sides") : "",
      "Side artwork": (S.mode==="custom"&&hasSide()&&sideImgOK()&&$("sfile").files&&$("sfile").files[0])
          ? ($("sfile").files[0].name+" \u2014 "+Math.round(S.siscale*100)+"%, "+Math.round(S.sirot)+"\u00b0, mirrored both sides") : "",
      "Text colours": hasHood()&&(S.addtext==="yes"||S.mode==="custom")
          ? (S.txtduo==="two" ? (colName("tout")+" outline + "+colName("tcol")+" fill") : colName("tcol")) : "",
      "Text font": hasHood()&&(S.addtext==="yes"||S.mode==="custom")&&S.txtsrc==="type"
          ? (($("cfont")&&$("cfont").value==="__other")?($("cfontother").value||""):($("cfont")?$("cfont").selectedOptions[0].textContent:"")) : "",
      "Text size / angle": hasHood()&&(S.addtext==="yes"||S.mode==="custom")
          ? (Math.round((S.txtsrc==="popular"&&S.badge?S.bscale:S.scale)*100)+"% \u00b7 "+Math.round(S.txtsrc==="popular"&&S.badge?S.brot:S.rot)+"\u00b0") : "",
      "Uploaded artwork": (S.mode==="custom"&&hasHood()&&$("cfile")&&$("cfile").files&&$("cfile").files[0])
          ? ($("cfile").files[0].name+" \u2014 placed at "+Math.round(S.iscale*100)+"%, "+Math.round(S.irot)+"\u00b0") : "",
      "Build code": $("spec")?$("spec").textContent:"",
      "Quoted price": "$"+price.toFixed(2)
    };
    if(((FAM[fam]||{}).words||[]).length) for(const k of Object.keys(props)){ const v=props[k]; delete props[k]; props[T(k)]=(k==="Order")?T(v):v; }
    // Shopify stores a file attached to the line item, but only on a real form post
    const src=$("cfile");
    if(src){
      let fileIn=form.querySelector('input[data-hb-file]');
      if(!fileIn){
        fileIn=document.createElement("input");
        fileIn.type="file"; fileIn.name="properties[Artwork file]";
        fileIn.setAttribute("data-hb-file","1");
        fileIn.style.display="none";
        form.appendChild(fileIn);
      }
      if(src.files&&src.files.length&&S.mode==="custom"&&hasHood()){
        try{ const dt=new DataTransfer(); dt.items.add(src.files[0]); fileIn.files=dt.files;
             form.setAttribute("enctype","multipart/form-data"); }catch(e){}
      } else {
        try{ fileIn.value=""; }catch(e){}
      }
    }
    // the side-decal artwork travels as its own file
    {const ss=$("sfile"); let fi=form.querySelector('input[data-hb-sfile]');
     if(!fi){ fi=document.createElement("input"); fi.type="file"; fi.name="properties[Side artwork file]";
       fi.setAttribute("data-hb-sfile","1"); fi.style.display="none"; form.appendChild(fi); }
     if(ss&&ss.files&&ss.files.length&&S.mode==="custom"&&hasSide()&&sideImgOK()){
       try{ const dt=new DataTransfer(); dt.items.add(ss.files[0]); fi.files=dt.files; form.setAttribute("enctype","multipart/form-data"); }catch(e){} }
     else { try{ fi.value=""; }catch(e){} }}
    form.querySelectorAll('input[data-hb-prop]').forEach(e=>e.remove());
    Object.keys(props).forEach(k=>{
      if(!props[k]) return;
      const i=document.createElement("input");
      i.type="hidden"; i.name="properties["+k+"]"; i.value=props[k]; i.setAttribute("data-hb-prop","1");
      form.appendChild(i);
    });
  }catch(e){ console.error('syncCart failed:', e && e.message); }
}
function trimLabel(){
  const ts=(D.fit.trims[S.model]||[]); const t=ts.find(x=>x.id===S.trim);
  return t?t.label:(S.trim==="__other"?"Other / not listed":"");
}
function colName(k){
  if(S[k]==="cutout") return "Cut-out (paint shows through)";
  if(S[k]==="other") return (S[k+"_txt"]||"custom colour");
  const all=[].concat(VIN,COL,VEH);
  const f=all.find(c=>c&&c.id===S[k]);
  return f?f.label:(S[k]||"");
}
// a truck can rename the add-on: on the Bronco it is the lower part of the hood, not hood side decals
const WORDS0=new WeakMap();
const T=t=>{ for(const [a,b] of (((FAM[fam]||{}).words)||[])) t=t.split(a).join(b); return t; };
function relabel(){
  const root=document.querySelector(".hood-builder #steps")||document.getElementById("steps"); if(!root) return;
  const tw=document.createTreeWalker(root,NodeFilter.SHOW_TEXT); let n;
  while((n=tw.nextNode())){ if(!WORDS0.has(n)) WORDS0.set(n,n.nodeValue);
    const t=T(WORDS0.get(n)); if(n.nodeValue!==t) n.nodeValue=t; }
}
function render(){ render0(); relabel(); }
function render0(){
 if(!FAM[fam]){ return; }
 VEH=vehList(); const veh=pick(VEH,"veh");
 // a truck whose photo runs taller than the screen (Bronco Raptor) is shown a little smaller
 {const stg=document.querySelector(".hood-builder .stage"); const k=(FAM[fam]||{}).stageScale;
  if(stg){ stg.style.width=k?(k*100)+"%":""; stg.style.marginInline=k?"auto":""; }}
 const m=pick(VIN,"main"), a=pick(VIN,"acc");
 const bc=pick(VIN,"bcol");
 const x=pick(VIN,"tcol");
 const r=document.documentElement.style;
 r.setProperty("--veh",veh?veh.hex:"#F2F2F2");
 r.setProperty("--main",m&&m.cut?"transparent":(m?m.hex:"#1C1C1C"));
 r.setProperty("--acc",a&&a.cut?"transparent":(a?a.hex:"#C8102E"));
 const a2=pick(VIN,"acc2"); r.setProperty("--acc2",a2&&a2.cut?"transparent":(a2?a2.hex:"#FFFFFF"));
 r.setProperty("--bcol",bc&&bc.cut?"transparent":(bc?bc.hex:"#C8102E"));
 r.setProperty("--tcol",x&&x.cut?"transparent":(x?x.hex:"#C8102E"));
 {const sc=pick(COL,"scol"); r.setProperty("--scol",sc?sc.hex:"#ED1C24");}

 const s1done=!!(S.year&&S.model&&S.trim&&S.hoodOK&&S.veh);
 $("s1sum").hidden=!s1done;
 if(s1done){
   const mdl=D.fit.models[S.model]?D.fit.models[S.model].label:S.model;
   const tr=(D.fit.trims[S.model]||[]).find(t=>t.id===S.trim);
   const pc=(PAINT[S.veh]||[""])[0];
   $("s1txt").textContent=S.year+" \u00b7 "+mdl+" \u00b7 "+(tr?tr.label:S.trim)+" \u00b7 "+S.hoodname+(pc?" \u00b7 "+pc:"");
 }
 $("s1in").hidden=s1done&&!S.s1open;
 $("hoodwrap").hidden=!S.trim;
 $("vehcol").hidden=!S.hoodOK;
 $("s1next").hidden=!(S.hoodOK&&S.veh);
 $("s4").classList.toggle("locked",!S.veh);
 $("s5").classList.toggle("locked",!S.veh);
 if(S.mode==="custom"&&libSides()&&S.pack==="side"){ S.pack="hood"; S.side=""; S.saddtext="no"; }
 const hoodDone=!hasHood()||(S.mode==="library"&&!!S.des)||S.mode==="custom";
 const sideDone=!hasSide()||(S.mode==="custom"&&!libSides())||!!S.side;
 const desDone=hoodDone&&sideDone;
 if(!hasHood()&&S.addtext!=="no"){ S.addtext="no"; }
 $("s7").classList.toggle("locked",!(S.mode&&desDone));
 [["s1",S.hoodOK],["s4",desDone],["s7",(S.addtext==="yes"||S.saddtext==="yes"||S.mode==="custom")],
  ["s5",desDone]]
   .forEach(([id,ok])=>$(id).classList.toggle("done",!!ok));

 $("veil").hidden=!!S.trim;
 $("cap").hidden=!S.hoodname; $("cap").textContent=S.hoodname||"";
 $("packwrap").hidden=!S.mode;
 {const P=prices(); $("from-lib").textContent="Starts from $"+Math.min(P.library.hood,P.library.side);
  $("from-cus").textContent="Starts from $"+Math.min(...["hood","side"].map(k=>P.custom[k]).filter(v=>v!=null));}
 $("g-lib").hidden=!(hasHood()&&S.mode==="library");
 $("g-custom").hidden=!(hasHood()&&S.mode==="custom");
 $("g-sidelib").hidden=!(hasSide()&&(S.mode==="library"||(S.mode==="custom"&&libSides())));
 $("g-scustom").hidden=!(hasSide()&&S.mode==="custom"&&!libSides());
 {const noimg=!!(FAM[fam]&&FAM[fam].sideNoImage);
  $("scus-upload").hidden=noimg; $("scus-textonly").hidden=!noimg;
  $("scus-title").textContent=noimg?"Hood side decals \u2014 your text":"Hood side decals \u2014 your artwork";}
 $("g-cdesc").hidden=S.mode!=="custom";
 $("htextwrap").hidden=!hasHood();
 $("stextwrap").hidden=!hasSide()||!!(FAM[fam]||{}).noSideText;
 if((FAM[fam]||{}).noSideText&&S.saddtext!=="no") S.saddtext="no";
 $("htextlb").textContent=hasSide()?"Text on the hood decal":"Add text";

 const useCut=a&&a.cut;
 const custom=S.mode==="custom";
 const active = !hasHood() ? null : (custom ? "blank" : (S.mode==="library"&&S.des ? S.des : null));
 // personalised side decals start from the plain side panels
 const activeSide = !hasSide() ? null : ((custom&&!libSides()) ? ((FAM[fam]||{}).plainSide||"style_39") : (S.side||null));
 const mainCut = !!(m && m.cut);
 if(mainCut) S.border="no";
 const lockNow = !!(FAM[fam].lock && FAM[fam].lock[S.des]);
 // a design whose edges must be the graphics colour forces the border on; when the
 // customer moves to another design, give them back the border choice they had
 // designs whose edge strips are part of the artwork (graphics colour) have no border
 // choice at all; the customer's own border setting is left untouched for the next design
 ORDERK.forEach(k=>{
   const el=$("d_"+fam+"_"+k); if(!el) return;
   const gko=el.querySelector(".gko");
   if(gko){ if(useCut) gko.setAttribute("mask","url(#gk_"+fam+"_"+k+")"); else gko.removeAttribute("mask"); }
   const lk = !!(FAM[fam].lock && FAM[fam].lock[k]);
   // the sheet trims the vinyl back from the edge strips; that trim only applies when the
   // strips are showing (border on, or strips built into the design)
   el.querySelectorAll(".gclip").forEach(g=>{ const c=g.getAttribute("data-clip"); if(!c) return;
     if(S.border==="yes"||lk) g.setAttribute("clip-path",c); else g.removeAttribute("clip-path"); });
   el.classList.toggle("b-on", S.border==="yes" && !lk);
   el.classList.toggle("b-acc", lk);
   // second colour cut out: the design is shown as drawn on the sheet - artwork in the
   // main colour, nothing behind it - including on the designs whose colours are swapped
   el.classList.toggle("acc-cut", !!useCut);
   // 2021+ designs carry their own cut-out masks: main vinyl cut keeps only the graphics,
   // graphics cut punches them through the main vinyl
   if(FAM[fam].dynMask){
     el.querySelectorAll("[data-mask]").forEach(g=>{ if(mainCut) g.setAttribute("mask",g.dataset.mask); else g.removeAttribute("mask"); });
     const g2el = k===activeSide && ((hasHood() && S.mode==="library" && !!((FAM[fam].two||{})[S.des]) && ((FAM[fam].gcol||{})[k]==="white")) || pairTwo());
     const gcut = g2el ? !!(a2&&a2.cut) : useCut;
     el.querySelectorAll("[data-gmask]").forEach(g=>{ if(gcut) g.setAttribute("mask",g.dataset.gmask); else g.removeAttribute("mask"); });
     el.querySelectorAll("[data-g2mask]").forEach(g=>{ if(a2&&a2.cut) g.setAttribute("mask",g.dataset.g2mask); else g.removeAttribute("mask"); });
   }
   // with a two-colour hood (red 1st, white 2nd), the white parts of a one-colour side decal
   // follow the 2nd colour, so white stays white on both
   {const t=(FAM[fam].two||{}), gc=(FAM[fam].gcol||{});
    el.classList.toggle("g2", k===activeSide && ((hasHood() && S.mode==="library" && !!t[S.des] && gc[k]==="white") || pairTwo()));}
   if(k===active||k===activeSide) el.removeAttribute("hidden"); else el.setAttribute("hidden","");
 });
 {const pop=(S.txtsrc==="popular"&&S.badge);
  const sc=pop?S.bscale:S.scale, ro=pop?S.brot:S.rot;
  $("csizen").textContent=Math.round(sc*100)+"%"; $("crotn").textContent=Math.round(ro)+"\u00b0";
  $("csize").value=Math.round(sc*100); $("crot").value=Math.round(ro);}
 // uploaded image on the vinyl (personalised path only)
 document.querySelectorAll("[id$=_img]").forEach(e=>e.setAttribute("hidden",""));
 $("imgctl").hidden=!(custom&&hasHood()&&UIMG);
 if(custom&&hasHood()&&UIMG){ const il=$("d_"+fam+"_img"); const ui=il.querySelector(".uimg"); const vbv=il.getAttribute("viewBox").split(" ").map(Number);
   const g=FAM[fam].geo; const w0=vbv[2]*0.45, h0=w0*UIH/UIW; const w=w0*S.iscale, h=h0*S.iscale;
   ui.setAttribute("href",UIMG); ui.setAttribute("width",w); ui.setAttribute("height",h);
   ui.setAttribute("x",g.x-w/2+S.ix); ui.setAttribute("y",g.y-h/2-vbv[3]*0.12+S.iy);
   ui.setAttribute("transform",`rotate(${S.irot} ${g.x+S.ix} ${g.y-vbv[3]*0.12+S.iy})`); ui.removeAttribute("hidden"); il.removeAttribute("hidden");
   $("isizen").textContent=Math.round(S.iscale*100)+"%"; $("irotn").textContent=Math.round(S.irot)+"\u00b0";
   // keep the sliders on the same value as the handles / pinch, or the next
   // slider touch would snap the image back to whatever the slider still held
   $("isize").value=Math.round(S.iscale*100); $("irot").value=Math.round(S.irot);
   const ih=HND(".ihandles");
   if(ih){ if(SEL==="img"){ ih.removeAttribute("hidden");
     const cx=g.x+S.ix, cy=g.y-vbv[3]*0.12+S.iy, ang=S.irot*Math.PI/180;
     const gk=gapK(vbv[2]), rr=h/2+13*gk, hw=w/2+9*gk, hh=h/2, kk=handleK(vbv[2]);
     grabArea(ih.querySelector(".ihrot")).setAttribute("transform",
       "translate("+(cx+Math.sin(ang)*rr)+","+(cy-Math.cos(ang)*rr)+") scale("+kk+")");
     grabArea(ih.querySelector(".ihsize")).setAttribute("transform",
       "translate("+(cx+Math.cos(ang)*hw-Math.sin(ang)*hh)+","+(cy+Math.sin(ang)*hw+Math.cos(ang)*hh)+") scale("+kk+")");
   } else ih.setAttribute("hidden",""); } }
 $("accnote").hidden=!(custom&&hasHood()&&UIMG);
 // explain cut-out wherever it is currently selected
 [["g-main","main"],["g-acc","acc"],["g-tcol2","tcol"]].forEach(([host,key])=>{
   const el=$(host); if(!el) return;
   let n=el.parentElement.querySelector(".cutnote");
   if(S[key]==="cutout"){
     if(!n){ n=document.createElement("p"); n.className="hint cutnote"; el.parentElement.appendChild(n); }
     n.textContent="Cut-out \u2014 there is no vinyl in this area, so your own paint shows through. "+
       "It arrives already cut and pre-masked; nothing for you to cut or trim.";
   } else if(n) n.remove();
 });
 // ---- popular text badges ----
 const showBadges = hasHood() && (custom || (S.mode==="library" && S.addtext==="yes")) && S.txtsrc==="popular";
 
 if(showBadges && !$("g-badge").dataset.built){
   $("g-badge").innerHTML=BADGE_ORDER.map(id=>{
     const b=BADGES[id];
     const out=b.outer.map(d=>b.stroke?`<path d="${d}" fill="none" stroke="#C8102E" stroke-width="${b.stroke}" stroke-linejoin="round"/>`
                                      :`<path d="${d}" fill="#C8102E"/>`).join("");
     const inn=b.inner.map(d=>`<path d="${d}" fill="#1C1C1C"/>`).join("");
     return `<button class="opt badgebtn" type="button" data-k="badge" data-v="${id}" aria-pressed="${S.badge===id}">`+
            `<svg viewBox="${b.vb}" preserveAspectRatio="xMidYMid meet">${out}${inn}</svg></button>`;
   }).join("");
   $("g-badge").dataset.built="1";
 }
 if(showBadges){
   [...$("g-badge").querySelectorAll("button")].forEach(b=>b.setAttribute("aria-pressed",String((b.dataset.v||"")===S.badge)));

 }
 document.querySelectorAll("[id$=_badge]").forEach(e=>e.setAttribute("hidden",""));
 if(showBadges && S.badge){
   const bl=$("d_"+fam+"_badge"), b=BADGES[S.badge];
   const vbb=bl.getAttribute("viewBox").split(" ").map(Number), g=FAM[fam].geo;
   const oc=pick(TOUT,"tout"), ic=pick(VIN,"tcol");
   // a Cut-out part has no colour of its own: draw it with no paint at all
   const ohex=oc?(oc.cut?"none":oc.hex):"#C8102E", ihex=ic?(ic.cut?"none":ic.hex):"#1C1C1C";
   const og=bl.querySelector(".bouter"), ig=bl.querySelector(".binner");
   if(og.dataset.b!==S.badge){
     og.innerHTML=b.outer.map(d=>b.stroke?`<path d="${d}" fill="none" stroke-width="${b.stroke}" stroke-linejoin="round"/>`
                                         :`<path d="${d}"/>`).join("");
     ig.innerHTML=b.inner.map(d=>`<path d="${d}"/>`).join("");
     og.dataset.b=S.badge;
   }
   const iCut=!!(ic&&ic.unknown===undefined&&S.tcol==="cutout");
   const two=S.txtduo==="two";
   og.querySelectorAll("path").forEach(p=>{ if(b.stroke) p.setAttribute("stroke",two?ohex:ihex); else p.setAttribute("fill",two?ohex:ihex); });
   ig.querySelectorAll("path").forEach(p=>p.setAttribute("fill",ihex));
   // fit the badge to a share of the vinyl width, then place / rotate / scale it
   // trucks drawn in their photo's own pixels (every hood but the 2015-2020 F-150): start the text
   // on the hood at the personalised-text spot, a bit narrower, instead of up under the cowl
   const fullStage=vbb[2]>=1000;
   // Sarya: 100% is the size that used to be 50%
   const bw=vbb[2]*(fullStage?0.2:0.275)*S.bscale, bh=bw*b.ratio;
   const sx=bw/(+b.vb.split(" ")[2]), sy=bh/(+b.vb.split(" ")[3]);
   const cx=g.x+S.bx, cy=g.y-(fullStage?0:vbb[3]*0.24)+S.by;
   const vx=+b.vb.split(" ")[0], vy=+b.vb.split(" ")[1];
   bl.querySelector(".bwrap").setAttribute("transform",
     `translate(${cx} ${cy}) rotate(${S.brot}) translate(${-bw/2} ${-bh/2}) scale(${sx} ${sy}) translate(${-vx} ${-vy})`);
   // cut-outs: single colour cut = whole badge cut; two colours = only that part is cut
   {const BL=textLook("tcol","tout","txtduo"), bw=bl.querySelector(".bwrap");
    bw.removeAttribute("opacity"); og.removeAttribute("mask"); og.removeAttribute("opacity"); ig.removeAttribute("opacity");
    if(BL.fillCut&&!BL.two) bw.setAttribute("opacity","0.001");
    else if(BL.outCut) og.setAttribute("opacity","0.001");
    else if(BL.fillCut){ ig.setAttribute("opacity","0.001");
      let mk=bl.querySelector("mask#bring_"+fam);
      if(!mk){ mk=document.createElementNS(SVGNS,"mask"); mk.id="bring_"+fam; mk.setAttribute("maskUnits","userSpaceOnUse");
        ["x","y"].forEach(a=>mk.setAttribute(a,"-100000")); ["width","height"].forEach(a=>mk.setAttribute(a,"200000"));
        let d=bl.querySelector("defs"); if(!d){ d=document.createElementNS(SVGNS,"defs"); bl.insertBefore(d,bl.firstChild); } d.appendChild(mk); }
      mk.innerHTML='<rect x="-100000" y="-100000" width="200000" height="200000" fill="#fff"/>'+
        b.inner.map(d=>`<path d="${d}" fill="#000" style="fill:#000!important;stroke:none!important"/>`).join("");
      og.setAttribute("mask","url(#bring_"+fam+")"); }}
   bl.removeAttribute("hidden");
   const bh2=HND(".bhandles");
   if(bh2&&SEL!=="badge") bh2.setAttribute("hidden","");
   else if(bh2){ bh2.removeAttribute("hidden");
     const gk=gapK(vbb[2]), ang=S.brot*Math.PI/180, rr=bh/2+13*gk, hw=bw/2+9*gk, hh=bh/2, kk=handleK(vbb[2]);
     grabArea(bh2.querySelector(".bhrot")).setAttribute("transform",
       "translate("+(cx+Math.sin(ang)*rr)+","+(cy-Math.cos(ang)*rr)+") scale("+kk+")");
     grabArea(bh2.querySelector(".bhsize")).setAttribute("transform",
       "translate("+(cx+Math.cos(ang)*hw-Math.sin(ang)*hh)+","+(cy+Math.sin(ang)*hw+Math.cos(ang)*hh)+") scale("+kk+")");
   }
 }
 // ---- text: type your own, or a popular one ----
 opts("g-txtsrc",SRCSEL,"txtsrc",false);
 const typing = S.txtsrc==="type";
 $("typewrap").hidden=!typing; $("popwrap").hidden=typing;
 if(typing && S.badge){ S.badge=""; S.bx=0; S.by=0; S.brot=0; S.bscale=1; }
 if(!typing && $("ctext") && $("ctext").value){ $("ctext").value=""; S.tx=0; S.ty=0; S.rot=0; S.scale=1; }
 opts("g-txtduo",DUO,"txtduo",false);
 if(S.txtduo==="two"&&S.tcol==="cutout"&&S.tout==="cutout") S.tout="black";
 opts("g-tcol2",VIN,"tcol",true,o=>o.cut&&S.txtduo==="two"&&S.tout==="cutout");
 $("toutwrap").hidden = S.txtduo!=="two";
 if(S.txtduo==="two") opts("g-tout",TOUT,"tout",true,o=>o.cut&&S.tcol==="cutout");
 const HL=textLook("tcol","tout","txtduo");

 const wantsText = hasHood() && (custom || (S.mode==="library" && S.addtext==="yes"));
 const txt = (wantsText && S.txtsrc!=="popular") ? ($("ctext").value||"").trim() : "";
 const font = fontValue();
 const t=$("d_"+fam+"_text").querySelector(".ctxt"), bx=+t.getAttribute("x"), by=+t.getAttribute("y");
 const tf = v => `translate(${S.tx*v[0]} ${S.ty*v[2]}) `;
 t.textContent = txt;
 t.setAttribute("font-family",font);
 paintText(t,HL);
 t.setAttribute("transform",
   `translate(${S.tx} ${S.ty}) rotate(${S.rot} ${bx} ${by}) `+
   `translate(${bx} ${by}) scale(${S.scale}) translate(${-bx} ${-by})`);
 document.querySelectorAll("[id$=_text]").forEach(e=>e.setAttribute("hidden",""));
 if(txt) $("d_"+fam+"_text").removeAttribute("hidden");
 // a cut-out shows through the mask, so the visible copy is invisible but still grabbable
 
 try{ const hl=HND(".thandles");
   const vbn2=$("d_"+fam+"_text").getAttribute("viewBox").split(" ").map(Number); if(hl){ if(txt){ hl.removeAttribute("hidden");
   if(SEL!=="text"){hl.setAttribute("hidden","");} else {
   const bb=t.getBBox();
   const gk=gapK(vbn2[2]);
   const ang=S.rot*Math.PI/180, dc=bb.height*0.35*S.scale, rr=bb.height*0.75*S.scale+13*gk;
   const kk=handleK(vbn2[2]);
   const rot=grabArea(hl.querySelector(".hrot")), sz=grabArea(hl.querySelector(".hsize"));
   // the visual centre of the text, turned with it (the text pivots on its baseline point)
   const cX=bx+S.tx+Math.sin(ang)*dc, cY=by+S.ty-Math.cos(ang)*dc;
   rot.setAttribute("transform","translate("+(cX+Math.sin(ang)*rr)+","+(cY-Math.cos(ang)*rr)+") scale("+kk+")");
   const hw=bb.width*0.5*S.scale+9*gk, hh=bb.height*0.4*S.scale;
   sz.setAttribute("transform","translate("+(bx+S.tx+Math.cos(ang)*hw-Math.sin(ang)*hh)+","+
     (by+S.ty+Math.sin(ang)*hw+Math.cos(ang)*hh)+") scale("+kk+")"); }
 } else hl.setAttribute("hidden",""); } }catch(e){}
 // knockout copy inside every design's mask
 ORDERK.forEach(k=>{
   const el=$("d_"+fam+"_"+k); if(!el) return;
   const kt=el.querySelector(".ktxt"); if(!kt) return;
   const c=[1,0,1,0], g=FAM[fam].geo;
   if((HL.fillCut||HL.outCut) && txt){
     const X=c[0]*bx+c[1], Y=c[2]*by+c[3];
     kt.textContent=txt; knockText(kt,HL,g.fs*0.16);
     kt.setAttribute("x",X); kt.setAttribute("y",Y);
     kt.setAttribute("font-size",g.fs);
     kt.setAttribute("font-family",font);
     kt.setAttribute("transform",
       `translate(${S.tx*c[0]} ${S.ty*c[2]}) rotate(${S.rot} ${X} ${Y}) `+
       `translate(${X} ${Y}) scale(${S.scale}) translate(${-X} ${-Y})`);
   } else kt.textContent="";
   // the badge, when its fill is set to cut-out
   const kb=el.querySelector(".kbadge");
   if(kb){
     const BL2=textLook("tcol","tout","txtduo");
     const bCut = (S.txtsrc==="popular" && S.badge && (BL2.fillCut||BL2.outCut));
     if(bCut){
       const bl=$("d_"+fam+"_badge"), bw=bl&&bl.querySelector(".bwrap");
       if(bw){
         const inner=bw.querySelector(".binner"), outer=bw.querySelector(".bouter");
         let d2="";
         // single-colour cut: the whole badge; two colours: just the part that is cut out
         const parts2 = !BL2.two ? [outer,inner] : (BL2.outCut ? [outer] : [inner]);
         parts2.forEach(gp=>{ if(!gp) return;
           gp.querySelectorAll("path").forEach(pp=>{
             const sw=pp.getAttribute("stroke-width");
             d2+='<path d="'+pp.getAttribute("d")+'" fill="#000" style="fill:#000!important;'+(sw?'stroke:#000!important;stroke-width:'+sw+'px!important':'stroke:none!important')+'"'+
                 (sw?' stroke="#000" stroke-width="'+sw+'" stroke-linejoin="round"':'')+'/>';
           });
         });
         kb.innerHTML='<g transform="'+(bw.getAttribute("transform")||"")+'">'+d2+'</g>';
       }
     } else kb.innerHTML="";
   }
   // the cut changed: point the layer at the mask under a new name, so the browser redraws the hole
   { const tk=kt.parentNode; if(tk&&tk.id&&!el.hasAttribute("hidden")){ const sig=tk.innerHTML;
       if(tk.__sig!==sig){ tk.__sig=sig; const ref=el.querySelector('[mask="url(#'+tk.id+')"]');
         if(ref){ const base=tk.getAttribute("data-base")||tk.id; tk.setAttribute("data-base",base);
           tk.__n=(tk.__n||0)+1; tk.id=base+"_v"+tk.__n; ref.setAttribute("mask","url(#"+tk.id+")"); } } } }
 });



 if(!$("hoodpick").hidden) drawHoods();
 opts("g-border",BORDER,"border",false);
 opts("g-border2",BORDER,"border",false);
 opts("g-bcol",COL,"bcol",true);
 // 2021+ side decals are one colour, no cut-out, no border
 {const mono=!!(FAM[fam]&&FAM[fam].sideMono);
  $("wrap-scol").hidden=!(mono&&hasSide());
  if(mono&&hasSide()) opts("g-scol",COL0,"scol",true);
  $("wrap-main").hidden=mono&&!hasHood(); $("wrap-acc").hidden=(mono&&!hasHood()&&!((FAM[fam]||{}).sideAcc))||noGfx();
  // one graphics colour: "Graphics colour"; two: "1st" and "2nd graphics colour"
  $("lb-acc").textContent=hasTwo()?"1st graphics colour":"Graphics colour";
  $("lb-main").textContent=(mono&&hasSide())?"Hood vinyl colour (main)":"Vinyl colour (main)";}

 // a truck whose designs have no border (Bronco Raptor) never offers one
 const noBd=!!((FAM[fam]||{}).noBorder); if(noBd) S.border="no";
 $("wrap-bcol").hidden = S.border!=="yes" || lockNow || !hasHood() || noBd;
 $("wrap-border2").hidden = lockNow || mainCut || noBd;
 $("wrap-border").hidden = mainCut || noBd;
 $("wrap-acc2").hidden = !hasTwo();
 if(hasTwo()) opts("g-acc2",VIN,"acc2",true,o=>o.cut&&S.main==="cutout"&&S.acc==="cutout");

 opts("g-addtext",(S.mode==="custom"?ADDT_FREE:ADDT),"addtext",false);
 $("textblock").hidden=!(S.addtext==="yes");
 opts("g-veh",VEH,"veh",true);
 opts("g-pack",packs(),"pack",false);
 opts("g-saddtext",(S.mode==="custom"&&!libSides()?ADDT_FREE:ADDT),"saddtext",false);
 opts("g-sduo",DUO,"sduo",false);
 if(S.sduo==="two"&&S.stcol==="cutout"&&S.stout==="cutout") S.stout="black";
 opts("g-stcol",VIN,"stcol",true,o=>o.cut&&S.sduo==="two"&&S.stout==="cutout");
 $("stoutwrap").hidden=S.sduo!=="two";
 if(S.sduo==="two") opts("g-stout",TOUT,"stout",true,o=>o.cut&&S.stcol==="cutout");
 drawSideArt();
 {// some trucks (F-150 Raptor) only pair side decals with the hood designs drawn for them
  const ok=(FAM[fam]||{}).sideOK, lim=!!(ok&&hasSide()&&hasHood()&&S.mode==="library");
  const hl=(lim?desList("hood").filter(d=>ok.includes(d.id)):desList("hood"))
    .map(d=>setSides(d.id).length?Object.assign({},d,{label:d.label+STAR}):d);
  opts("g-des",hl,"des",false);
  $("sideoknote").hidden=!lim;}
 {// side decals drawn on the same sheet as the chosen hood decal come first, marked as a matching set
  const mt=(hasHood()&&S.mode==="library"&&S.des&&((FAM[fam]||{}).match||{})[S.des])||[];
  const all=desList("side");
  const items=mt.length ? mt.map(id=>all.find(d=>d.id===id)).filter(Boolean).map(d=>Object.assign({},d,{label:d.label+'<span class="match">\u2605 Matching set</span>'}))
                           .concat(all.filter(d=>!mt.includes(d.id))) : all.map(d=>setFront(d.id)?Object.assign({},d,{label:d.label+STAR}):d);
  opts("g-side",items,"side",false);
  $("matchnote").hidden=!mt.length;}
 {// a design that comes as a complete set offers its other piece, one click away
  const P=prices().library, lib=S.mode==="library", sh=$("setnote-h"), ss=$("setnote-s");
  const mt=setSides(S.des), fr=S.side?setFront(S.side):null;
  const okF=id=>{const ok=(FAM[fam]||{}).sideOK; return !ok||ok.includes(id);};
  if(lib&&S.pack==="hood"&&S.des&&mt.length&&!(FAM[fam]||{}).noSide){
    sh.innerHTML='<p><b>\u2605 Best as a complete set.</b> This design is made to go with its matching '+nounSide()+'.</p>'+
      '<button class="opt setadd" type="button" data-k="setadd" data-v="side">Add the matching '+nounSide()+' (+$'+(P.both-P.hood)+')</button>';
    sh.hidden=false;
  } else sh.hidden=true;
  if(lib&&S.pack==="side"&&fr&&okF(fr)){
    const lab=((desOf(fr)||{}).label)||fr;
    ss.innerHTML='<p><b>\u2605 Best as a complete set.</b> This design is made to go with '+nounHood()+' '+lab+'.</p>'+
      '<button class="opt setadd" type="button" data-k="setadd" data-v="hood">Add '+nounHood()+' '+lab+' (+$'+(P.both-P.side)+')</button>';
    ss.hidden=false;
  } else ss.hidden=true;}
 if(lockNow){ if(S.main==="cutout")S.main="black"; if(S.acc==="cutout")S.acc="red"; }
 // a plain design is all main vinyl: cutting that out would leave nothing
 if(noGfx()&&S.main==="cutout") S.main="black";
 opts("g-main",VIN,"main",true,o=>o.cut&&(S.acc==="cutout"||lockNow||noGfx()));
 opts("g-acc",VIN,"acc",true,o=>o.cut&&(S.main==="cutout"||lockNow));
 document.querySelectorAll('[data-k="mode"]').forEach(b=>
   b.setAttribute("aria-pressed",S.mode===b.dataset.v));

 const price=quote();
 $("price").textContent="$"+price.toFixed(2);
 const cname=k=>S[k]==="other"?("OTHER("+((S[k+"_txt"]||"?").trim())+")"):String(S[k]||"").toUpperCase();
 const parts=[];
 if(S.year&&S.model)parts.push(S.year+"-"+S.model.toUpperCase());
 if(S.trim)parts.push(S.trim.toUpperCase());
 if(S.hoodOK)parts.push("HOOD-"+(S.hood||"std").toUpperCase());
 if(S.veh)parts.push("CAR-"+cname("veh"));
 parts.push("ORDER-"+(S.pack==="both"?"HOOD+SIDE":S.pack==="side"?"SIDE":"HOOD"));
 if(hText())parts.push("ADDED-TEXT");
 if(hasHood()&&(S.mode==="custom"||(S.mode==="library"&&S.addtext==="yes"))){
   if(S.badge)parts.push("BADGE-"+S.badge.toUpperCase()+"("+cname("bout")+"/"+cname("bin")+")-"+
     Math.round(S.bscale*100)+"%-"+Math.round(S.brot)+"deg");
   if(S.txtduo==="two")parts.push("TXT-OUTLINE-"+cname("tout"));
   if(S.mode==="custom")parts.push("HOOD-CUSTOM-DESIGN"); if(S.mode==="custom"&&UIMG)parts.push("IMG-"+Math.round(S.iscale*100)+"%-"+Math.round(S.irot)+"deg-"+Math.round(S.ix)+","+Math.round(S.iy));
   const tv=(S.txtsrc==="popular")?"":($("ctext").value||"").trim();
   if(tv)parts.push('TEXT-"'+tv+'"');
   if(tv){parts.push("FONT-"+($("cfont").value==="__other"?($("cfontother").value||"?"):$("cfont").selectedOptions[0].textContent.split(" \u2014")[0]).toUpperCase());
     parts.push("SIZE-"+Math.round(S.scale*100)+"%");
     if(S.rot)parts.push("ROT-"+S.rot+"deg");
     if(S.tx||S.ty)parts.push("POS-"+Math.round(S.tx)+","+Math.round(S.ty));}
   if(txt||S.badge)parts.push("TXTCOL-"+(x&&x.cut?"CUTOUT":cname("tcol")));}
 const lkB=S.mode!=="custom"&&FAM[fam]&&FAM[fam].lock&&FAM[fam].lock[S.des];
 if(hasHood()&&S.border==="yes"&&!lkB)parts.push("BORDERCOL-"+(bc&&bc.cut?"CUTOUT":cname("bcol")));
 if(hasHood()&&(S.des||S.mode==="custom"))parts.push("BORDER-"+(lkB?"INDESIGN":(S.border==="yes"?"YES":"NO")));
 // design numbers as the customer sees them, plus the page of the artwork sheet for production
 const dcode=(pre,id)=>{const d=desOf(id); if(!d) return "";
   return pre+"-STYLE"+String(d.num).padStart(2,"0")+(d.page?"(SHEET-P"+String(d.page).padStart(2,"0")+")":"(PLAIN)");};
 if(hasHood()&&S.mode==="library"&&S.des)parts.push(dcode("HOOD",S.des));
 if(hasSide()&&(S.mode==="library"||libSides())&&S.side)parts.push(dcode("SIDE",S.side));
 if(hasSide()&&S.mode==="custom"&&!libSides())parts.push("SIDE-CUSTOM-DESIGN"+(SIMG&&sideImgOK()?"(IMG-"+Math.round(S.siscale*100)+"%-"+Math.round(S.sirot)+"deg-"+Math.round(S.six)+","+Math.round(S.siy)+")":""));
 {const st=($("stext").value||"").trim();
  if(hasSide()&&S.saddtext==="yes"&&st){
   parts.push('SIDE-TEXT-"'+st+'"'); parts.push("SIDE-FONT-"+sideFontName().toUpperCase());
   if(S.sduo==="two")parts.push("SIDE-TXT-OUTLINE-"+cname("stout"));
   parts.push("SIDE-TXTCOL-"+cname("stcol")); parts.push("SIDE-TXT-"+Math.round(S.ssc*100)+"%-"+Math.round(S.sro)+"deg-"+Math.round(S.sx)+","+Math.round(S.sy)+"-MIRRORED");}}
 if(FAM[fam]&&FAM[fam].sideMono&&hasSide()&&(S.side||S.mode==="custom")) parts.push("SIDECOL-"+cname("scol"));
 // Lightning: the side strips' light-blue details are in the graphics colour
 if(FAM[fam]&&FAM[fam].sideAcc&&hasSide()&&S.side&&!hasHood()) parts.push("GFX-"+(a&&a.cut?"CUTOUT":cname("acc")));
 if((hasHood()&&(S.des||S.mode==="custom"))||(!(FAM[fam]&&FAM[fam].sideMono)&&hasSide()&&(S.side||S.mode==="custom"))){
   parts.push("MAIN-"+(m&&m.cut?"CUTOUT":cname("main")));
   if(!noGfx()) parts.push("GFX-"+(a&&a.cut?"CUTOUT":cname("acc")));
   if(hasTwo()) parts.push("GFX2-"+(a2&&a2.cut?"CUTOUT":cname("acc2")));}
 $("spec").textContent=parts.length?parts.join(" | "):"Complete the steps above.";
 syncHandles();
 // after #spec is written, so the Build code property matches what the customer sees
 syncCart(price);
}

document.addEventListener("input",e=>{
 const b=e.target.closest("input.othbox"); if(!b) return;
 S[b.dataset.ok+"_txt"]=b.value; const el=document.activeElement===b; render();
 if(el){const n=document.querySelector(`input.othbox[data-ok="${b.dataset.ok}"]`); if(n){n.focus();n.setSelectionRange(n.value.length,n.value.length);}}
});
document.addEventListener("click",e=>{
 const b=e.target.closest("button.opt,button.hood"); if(!b||b.disabled) return;
 const k=b.dataset.k,v=b.dataset.v; if(!k) return;
 if(k==="hood"){S.hood=v;const h=(D.hoods[S.model]||[]).find(x=>x[0]===v);
   S.hoodname=h?h[1]:v; pickFam();}
 else if(k==="veh"){S.veh=v; if(!S.touched) applyDefaults();}
 else if(k==="main"||k==="acc"||k==="acc2"){S[k]=v;S.touched=true;
   if(S.main==="cutout"&&S.acc==="cutout") S[k==="main"?"acc":"main"]="red";}
 else if(k==="setadd"){
   if(v==="side"){ const mt=setSides(S.des); S.pack="both"; if(mt.length) S.side=mt[0]; }
   else { const fr=setFront(S.side); S.pack="both"; if(fr) S.des=fr; }
 }
 else if(k==="des"&&S.mode==="library"&&S.pack==="both"){
   // picking a set design fills in its matching piece, unless the customer already chose a piece of their own
   const prev=setSides(S.des), mt=setSides(v);
   S.des=v; if(mt.length&&(!S.side||prev.includes(S.side))) S.side=mt[0];
 }
 else if(k==="side"&&S.mode==="library"&&S.pack==="both"){
   S.side=v; const fr=setFront(v), ok=(FAM[fam]||{}).sideOK;
   if(fr&&!S.des&&(!ok||ok.includes(fr))) S.des=fr;
 }
 else if(k==="pack"){
   const was=S.pack;
   S.pack=v;
   if(v==="both"&&S.mode==="library"){
     if(was==="hood"&&S.des&&!S.side&&setSides(S.des).length) S.side=setSides(S.des)[0];
     if(was==="side"&&S.side&&!S.des&&setFront(S.side)){ const ok=(FAM[fam]||{}).sideOK, fr=setFront(S.side); if(!ok||ok.includes(fr)) S.des=fr; }
   }
   {const ok=(FAM[fam]||{}).sideOK; if(ok&&v==="both"&&S.des&&!ok.includes(S.des)) S.des="";}
   if(!hasHood()){ S.des=""; S.addtext="no"; }
   if(!hasSide()){ S.side=""; S.saddtext="no"; }
 }
 else if(k==="saddtext"){ S.saddtext=v; if(v==="no"){ $("stext").value=""; S.sx=0;S.sy=0;S.sro=0;S.ssc=1; } }
 else if(k==="addtext"){S.addtext=v; if(v==="no"){S.badge="";S.txtsrc="type";if($("ctext"))$("ctext").value="";S.tx=0;S.ty=0;S.rot=0;S.scale=1;S.bx=0;S.by=0;S.brot=0;S.bscale=1;}}
 else if(k==="mode"){
   if(S.mode!==v) resetDesign();
   S.mode=v;
   // 2021+ F-150 has no personalised side decals on their own
   if(v==="custom"&&libSides()&&S.pack==="side") S.pack="hood";
 }
 else S[k]=v;
 // a design drawn in one graphic colour starts in its own colour (white or red, as on the sheet)
 // until the customer picks colours themselves
 if((k==="des"||k==="side")&&!S.touched){ const gc=((FAM[fam]||{}).gcol||{})[v];
   if(gc && !(k==="side"&&hasHood()&&S.des)) S.acc=gc;
   if(k==="des"&&((FAM[fam]||{}).two||{})[v]){ S.acc="red"; S.acc2="white"; }
   if(pairTwo()){ const g=(FAM[fam]||{}).gcol||{}; S.acc=g[S.des]; S.acc2=g[S.side]; } }
 render();
});
document.addEventListener("click",ev=>{
  const btn=ev.target.closest&&ev.target.closest('[name="add"]');
  if(!btn) return;
  const form=btn.closest('form[action*="/cart/add"]');
  if(!form) return;
  if(btn.dataset.hbGo==="1"){ delete btn.dataset.hbGo; return; }
  ev.preventDefault(); ev.stopImmediatePropagation();
  const old=btn.textContent;
  btn.textContent="Preparing your preview\u2026"; btn.disabled=true;
  (async()=>{
    try{
      const blob=await snapshot();
      if(blob){
        let pv=form.querySelector('input[data-hb-preview]');
        if(!pv){
          pv=document.createElement("input"); pv.type="file";
          pv.name="properties[Preview image]";
          pv.setAttribute("data-hb-preview","1"); pv.style.display="none";
          form.appendChild(pv);
        }
        const dt=new DataTransfer();
        dt.items.add(new File([blob],"hood-preview.png",{type:"image/png"}));
        pv.files=dt.files;
      }
    }catch(e){ console.warn("preview snapshot failed",e); }
    btn.textContent=old; btn.disabled=false;
    const hasFile=[...form.querySelectorAll('input[type=file]')].some(x=>x.files&&x.files.length);
    if(hasFile){
      form.setAttribute("enctype","multipart/form-data");
      form.submit();
    } else {
      btn.dataset.hbGo="1"; btn.click();
    }
  })();
},true);
loadFam("f13").then(()=>{ORDERK=(FAM.f13||{}).order||[]; document.querySelectorAll(".veh").forEach(v=>v.hidden=(v.dataset.fam!==fam)); render();});

})();